
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire54aa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire54aa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("RJkEF", function(module, exports) {
module.exports = import("1iL9Y").then(()=>parcelRequire('C3MXw'));

});

parcelRegister("cJ4SL", function(module, exports) {
module.exports = import("jugIs").then(()=>parcelRequire('2UEBG'));

});

const $f07d147227763a00$export$7d15b64cf5a3a4c4 = (n, low, high)=>Math.max(low, Math.min(high, n));
const $f07d147227763a00$export$923fe2085dc4a98c = (a, b)=>a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
function $f07d147227763a00$export$aafa59e2e03f2942(key, fallback) {
    try {
        return JSON.parse(localStorage.getItem(key)) ?? fallback;
    } catch  {
        return fallback;
    }
}
function $f07d147227763a00$export$a1544dad697b423d(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch  {}
}
function $f07d147227763a00$export$b53e1522c5b09138(seed) {
    let n = 2166136261;
    for (const c of String(seed))n = Math.imul(n ^ c.charCodeAt(0), 16777619);
    return ()=>{
        n += 0x6D2B79F5;
        let t = n;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
let $f07d147227763a00$var$muted = $f07d147227763a00$export$aafa59e2e03f2942('ed-muted', false) === true;
let $f07d147227763a00$var$audio;
const $f07d147227763a00$export$589e67d858c44a42 = ()=>$f07d147227763a00$var$muted;
function $f07d147227763a00$export$f29aa9650e04f442() {
    document.querySelectorAll('audio').forEach((a)=>{
        a.pause();
        a.currentTime = 0;
    });
}
function $f07d147227763a00$export$a1680ba91cc9be33(value) {
    $f07d147227763a00$var$muted = value;
    $f07d147227763a00$export$a1544dad697b423d('ed-muted', value);
    document.querySelectorAll('audio').forEach((a)=>{
        a.muted = value;
    });
    if (value) {
        $f07d147227763a00$export$f29aa9650e04f442();
        if ($f07d147227763a00$var$audio) $f07d147227763a00$var$audio.suspend().catch(()=>{});
    } else $f07d147227763a00$export$3f66b274a2143589();
    document.dispatchEvent(new CustomEvent('ed-sound-change'));
}
function $f07d147227763a00$export$3f66b274a2143589() {
    if ($f07d147227763a00$var$muted) return;
    try {
        $f07d147227763a00$var$audio ||= new (window.AudioContext || window.webkitAudioContext)();
        if ($f07d147227763a00$var$audio.state === 'suspended') $f07d147227763a00$var$audio.resume().catch(()=>{});
    } catch  {}
}
function $f07d147227763a00$export$7297c25227171a1f(kind = 'shot') {
    if ($f07d147227763a00$var$muted || !$f07d147227763a00$var$audio || $f07d147227763a00$var$audio.state !== 'running') return;
    const notes = {
        shot: [
            640,
            220,
            .045
        ],
        hit: [
            180,
            45,
            .12
        ],
        collect: [
            420,
            1000,
            .15
        ],
        clear: [
            800,
            1600,
            .09
        ],
        hurt: [
            160,
            60,
            .24
        ],
        wave: [
            330,
            880,
            .35
        ]
    };
    const [start, end, duration] = notes[kind] || notes.shot;
    const osc = $f07d147227763a00$var$audio.createOscillator(), gain = $f07d147227763a00$var$audio.createGain(), now = $f07d147227763a00$var$audio.currentTime;
    osc.type = kind === 'hurt' ? 'sawtooth' : 'square';
    osc.frequency.setValueAtTime(start, now);
    osc.frequency.exponentialRampToValueAtTime(end, now + duration);
    gain.gain.setValueAtTime(.035, now);
    gain.gain.exponentialRampToValueAtTime(.001, now + duration);
    osc.connect(gain);
    gain.connect($f07d147227763a00$var$audio.destination);
    osc.start();
    osc.stop(now + duration);
}
function $f07d147227763a00$export$4c0029b0ace0292a(id) {
    document.dispatchEvent(new CustomEvent('ed-discover', {
        detail: id
    }));
}
async function $f07d147227763a00$export$c8531afc97e1e0f8(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        const field = document.createElement('textarea');
        field.value = text;
        field.className = 'copy-fallback';
        (document.querySelector('dialog[open]') || document.body).append(field);
        field.select();
        let ok = false;
        try {
            ok = document.execCommand('copy');
        } catch  {}
        field.remove();
        return ok;
    }
}
function $f07d147227763a00$export$1237798dc640739a(ctx, text, x, y, size = 18, color = '#e8f1ff', align = 'left') {
    ctx.font = `bold ${size}px "Courier Prime", monospace`;
    ctx.fillStyle = color;
    ctx.textAlign = align;
    ctx.fillText(text, x, y);
}


class $c1b0f4343ba38314$export$33fe5d76f4f0235c {
    constructor(random, finish){
        this.random = random;
        this.finish = finish;
        this.score = 0;
        this.level = 0;
        this.lives = 3;
        this.time = 0;
        this.player = {
            x: 300,
            y: 637
        };
        this.shield = 0;
        this.double = 0;
        this.invincible = 2;
        this.bullets = [];
        this.shots = [];
        this.enemies = [];
        this.pickups = [];
        this.particles = [];
        this.popups = [];
        this.cooldown = 0;
        this.transition = 2;
        this.banner = 'READY, PILOT';
        this.bannerTime = 0;
        this.over = false;
        this.kills = 0;
        this.stars = Array.from({
            length: 65
        }, (_, i)=>({
                x: i * 137 % 600,
                y: i * 97 % 700,
                speed: 20 + i % 40
            }));
    }
    wave() {
        this.level++;
        this.shots = [];
        this.bullets = [];
        this.invincible = Math.max(this.invincible, 1.5);
        this.boss = this.level % 5 === 0;
        this.bonus = !this.boss && this.level % 4 === 0;
        this.waveTime = 0;
        this.waveKills = 0;
        this.banner = this.boss ? 'WARNING: FLAGSHIP' : this.bonus ? "BONUS FLIGHT \u2014 NO ENEMY FIRE" : `WAVE ${this.level}`;
        this.bannerTime = 2.2;
        (0, $f07d147227763a00$export$7297c25227171a1f)('wave');
        if (this.boss) this.enemies = [
            {
                x: 235,
                y: -110,
                w: 130,
                h: 80,
                homeX: 235,
                homeY: 100,
                hp: 35 + this.level * 3,
                maxHp: 35 + this.level * 3,
                type: 3,
                phase: 0,
                dive: 0,
                points: 1500,
                entry: 0
            }
        ];
        else {
            const count = this.bonus ? 20 : 24 + Math.min(12, Math.floor(this.level / 2) * 6);
            this.enemies = Array.from({
                length: count
            }, (_, i)=>({
                    x: i % 2 ? -60 : 660,
                    y: -80 - i * 20,
                    w: 32,
                    h: 28,
                    homeX: 77 + i % 6 * 78,
                    homeY: 92 + Math.floor(i / 6) * 46,
                    hp: i < 6 && this.level > 2 ? 2 : 1,
                    type: i < 6 ? 0 : i < 12 ? 1 : 2,
                    phase: this.random() * Math.PI * 2,
                    dive: 0,
                    points: i < 6 ? 80 : 40,
                    entry: i * .065
                }));
        }
        this.attackTimer = 2.8;
        this.fireTimer = 1.4;
        this.totalInWave = this.enemies.length;
    }
    burst(x, y, color, count = 14) {
        for(let i = 0; i < count; i++){
            const a = i / count * Math.PI * 2;
            this.particles.push({
                x: x,
                y: y,
                vx: Math.cos(a) * (65 + i * 5),
                vy: Math.sin(a) * (65 + i * 5),
                life: .5,
                color: color
            });
        }
    }
    damage() {
        if (this.invincible > 0 || this.over) return;
        if (this.shield > 0) this.shield = 0;
        else this.lives--;
        this.invincible = 2;
        this.shots = [];
        this.burst(this.player.x, this.player.y, '#ff6b89', 24);
        (0, $f07d147227763a00$export$7297c25227171a1f)('hurt');
        if (this.lives <= 0) {
            this.over = true;
            this.finish({
                score: this.score,
                level: this.level,
                detail: `${this.kills} enemies down`,
                achievement: this.level >= 5 ? 'Flagship encounter' : this.score >= 1000 ? 'Ace in training' : 'First flight'
            });
        }
    }
    update(dt, input) {
        if (this.over) return;
        this.time += dt;
        this.invincible -= dt;
        this.double = Math.max(0, this.double - dt);
        this.bannerTime -= dt;
        this.stars.forEach((s)=>{
            s.y = (s.y + s.speed * dt) % 700;
        });
        this.particles.forEach((p)=>{
            p.x += p.vx * dt;
            p.y += p.vy * dt;
            p.life -= dt;
        });
        this.particles = this.particles.filter((p)=>p.life > 0);
        this.popups.forEach((p)=>{
            p.y -= dt * 30;
            p.life -= dt;
        });
        this.popups = this.popups.filter((p)=>p.life > 0);
        if (input.targetX != null) this.player.x += (0, $f07d147227763a00$export$7d15b64cf5a3a4c4)(input.targetX - this.player.x, -480 * dt, 480 * dt);
        else this.player.x += ((input.right ? 1 : 0) - (input.left ? 1 : 0)) * 360 * dt;
        this.player.x = (0, $f07d147227763a00$export$7d15b64cf5a3a4c4)(this.player.x, 22, 578);
        this.pickups.forEach((p)=>{
            p.y += 110 * dt;
            if ((0, $f07d147227763a00$export$923fe2085dc4a98c)(p, {
                x: this.player.x - 22,
                y: this.player.y - 22,
                w: 44,
                h: 44
            })) {
                if (p.type === 'shield') this.shield = 1;
                else this.double = 12;
                p.y = 800;
                (0, $f07d147227763a00$export$7297c25227171a1f)('collect');
                this.popups.push({
                    x: this.player.x,
                    y: this.player.y - 30,
                    text: p.type === 'shield' ? 'SHIELD' : 'DOUBLE SHOT',
                    life: 1.2
                });
            }
        });
        this.pickups = this.pickups.filter((p)=>p.y < 720);
        if (this.transition > 0) {
            this.transition -= dt;
            if (this.transition <= 0) this.wave();
            return;
        }
        this.waveTime += dt;
        this.cooldown -= dt;
        if ((input.shoot || input.pointer) && this.cooldown <= 0) {
            for (const offset of this.double > 0 ? [
                -12,
                12
            ] : [
                0
            ])this.bullets.push({
                x: this.player.x + offset - 2,
                y: this.player.y - 22,
                w: 4,
                h: 15
            });
            this.cooldown = .16;
            (0, $f07d147227763a00$export$7297c25227171a1f)('shot');
        }
        this.bullets.forEach((b)=>b.y -= 540 * dt);
        this.bullets = this.bullets.filter((b)=>b.y > -20 && !b.dead);
        this.shots.forEach((b)=>{
            b.y += b.vy * dt;
            b.x += b.vx * dt;
        });
        this.shots = this.shots.filter((b)=>b.y < 730 && b.x > -20 && b.x < 620);
        this.attackTimer -= dt;
        this.fireTimer -= dt;
        if (!this.boss && this.waveTime > 3 && this.attackTimer <= 0) {
            const ready = this.enemies.filter((e)=>!e.dive && !e.dead);
            if (ready.length) {
                const e = ready[Math.floor(this.random() * ready.length)];
                e.dive = .01;
                e.diveX = e.x;
            }
            this.attackTimer = this.bonus ? .25 : Math.max(.65, 2 - this.level * .12);
        }
        if (!this.bonus && this.waveTime > 2 && this.fireTimer <= 0 && this.enemies.length) {
            const e = this.enemies[Math.floor(this.random() * this.enemies.length)];
            const speed = Math.min(320, 170 + this.level * 12);
            const aim = (0, $f07d147227763a00$export$7d15b64cf5a3a4c4)((this.player.x - e.x - e.w / 2) * .5, -100, 100);
            for (const spread of this.boss ? [
                -90,
                -45,
                0,
                45,
                90
            ] : [
                0
            ])this.shots.push({
                x: e.x + e.w / 2,
                y: e.y + e.h,
                w: 7,
                h: 14,
                vx: aim + spread,
                vy: speed
            });
            this.fireTimer = Math.max(.24, .95 - this.level * .045);
        }
        for (const e of this.enemies){
            if (this.waveTime < e.entry) continue;
            if (e.dive) {
                e.dive += dt;
                e.y += (this.bonus ? 240 : 195 + this.level * 7) * dt;
                e.x = e.diveX + Math.sin(e.dive * 3) * 95;
                if (e.y > 730) {
                    if (this.bonus) e.dead = true;
                    else {
                        e.dive = 0;
                        e.y = -60;
                    }
                }
            } else {
                const target = e.homeX + Math.sin(this.waveTime * (this.boss ? 1 : .7)) * (this.boss ? 160 : 35);
                e.x += (target - e.x) * Math.min(1, dt * 3);
                e.y += (e.homeY - e.y) * Math.min(1, dt * 3);
            }
            for (const b of this.bullets)if (!b.dead && !e.dead && (0, $f07d147227763a00$export$923fe2085dc4a98c)(b, e)) {
                b.dead = true;
                e.hp--;
                e.flash = .09;
                if (e.hp <= 0) {
                    e.dead = true;
                    this.kills++;
                    this.waveKills++;
                    this.score += e.points;
                    this.burst(e.x + e.w / 2, e.y + e.h / 2, [
                        '#ff5fa2',
                        '#69deff',
                        '#ffe27a',
                        '#b89aff'
                    ][e.type], this.boss ? 40 : 14);
                    this.popups.push({
                        x: e.x,
                        y: e.y,
                        text: `+${e.points}`,
                        life: .7
                    });
                    (0, $f07d147227763a00$export$7297c25227171a1f)('hit');
                    if (this.kills % 9 === 0 || this.boss) this.pickups.push({
                        x: e.x,
                        y: e.y,
                        w: 25,
                        h: 25,
                        type: this.kills % 18 === 0 ? 'shield' : 'double'
                    });
                }
            }
            e.flash = Math.max(0, (e.flash || 0) - dt);
            if (!e.dead && (0, $f07d147227763a00$export$923fe2085dc4a98c)({
                x: this.player.x - 12,
                y: this.player.y - 12,
                w: 24,
                h: 24
            }, e)) this.damage();
            if (this.over) return;
        }
        this.enemies = this.enemies.filter((e)=>!e.dead);
        const playerBox = {
            x: this.player.x - 11,
            y: this.player.y - 11,
            w: 22,
            h: 24
        };
        for (const b of this.shots)if ((0, $f07d147227763a00$export$923fe2085dc4a98c)(b, playerBox)) {
            this.damage();
            break;
        }
        if (this.over) return;
        if (!this.enemies.length && !this.over) {
            const bonus = this.bonus ? this.waveKills * 100 : 200;
            this.score += bonus;
            this.transition = 2.4;
            this.shots = [];
            this.banner = this.bonus ? `BONUS: ${this.waveKills}/${this.totalInWave} \u{2022} +${bonus}` : `WAVE CLEAR \u{2022} +${bonus}`;
            (0, $f07d147227763a00$export$7297c25227171a1f)('collect');
        }
    }
    draw(ctx, reduced) {
        ctx.fillStyle = '#080d23';
        ctx.fillRect(0, 0, 600, 700);
        for (const s of this.stars){
            ctx.fillStyle = s.speed > 45 ? '#8aa6ce' : '#334564';
            ctx.fillRect(s.x, reduced ? s.speed * 97 % 700 : s.y, 2, 2);
        }
        ctx.fillStyle = '#111c36';
        ctx.fillRect(0, 0, 600, 51);
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, String(this.score).padStart(6, '0'), 20, 33, 23);
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, `WAVE ${this.level || 1}`, 300, 32, 17, '#a8b9dd', 'center');
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, `${"\u2665 ".repeat(Math.max(0, this.lives))}`, 582, 33, 22, '#ff789e', 'right');
        for (const e of this.enemies){
            const x = e.x + e.w / 2, y = e.y + e.h / 2;
            ctx.save();
            ctx.translate(x, y);
            if (e.dive) ctx.rotate(Math.sin(e.dive * 3) * .4);
            ctx.fillStyle = e.flash ? '#fff' : [
                '#ff5fa2',
                '#69deff',
                '#ffe27a',
                '#b89aff'
            ][e.type];
            if (e.type === 3) {
                ctx.beginPath();
                ctx.moveTo(-65, 18);
                ctx.lineTo(-48, -25);
                ctx.lineTo(-20, -10);
                ctx.lineTo(0, -40);
                ctx.lineTo(20, -10);
                ctx.lineTo(48, -25);
                ctx.lineTo(65, 18);
                ctx.lineTo(0, 40);
                ctx.closePath();
                ctx.fill();
                ctx.fillStyle = '#ff4e7c';
                ctx.fillRect(-28, -3, 56, 9);
            } else {
                ctx.beginPath();
                ctx.ellipse(0, 0, e.type === 1 ? 9 : 15, 12, 0, 0, Math.PI * 2);
                ctx.fill();
                if (e.type === 1) {
                    ctx.fillRect(-22, -10, 12, 18);
                    ctx.fillRect(10, -10, 12, 18);
                }
                if (e.type === 0) {
                    ctx.fillRect(-11, -18, 5, 10);
                    ctx.fillRect(6, -18, 5, 10);
                }
                ctx.fillStyle = '#080d23';
                ctx.fillRect(-8, -4, 5, 5);
                ctx.fillRect(3, -4, 5, 5);
            }
            ctx.restore();
            if (e.type === 3) {
                ctx.fillStyle = '#253153';
                ctx.fillRect(160, 58, 280, 6);
                ctx.fillStyle = '#b89aff';
                ctx.fillRect(160, 58, 280 * e.hp / e.maxHp, 6);
            }
        }
        ctx.fillStyle = '#8dffd9';
        for (const b of this.bullets)if (!b.dead) ctx.fillRect(b.x, b.y, b.w, b.h);
        ctx.fillStyle = '#ff708c';
        for (const b of this.shots)ctx.fillRect(b.x, b.y, b.w, b.h);
        for (const p of this.pickups){
            ctx.fillStyle = p.type === 'shield' ? '#68dfff' : '#a0ffa5';
            ctx.fillRect(p.x, p.y, 25, 25);
            (0, $f07d147227763a00$export$1237798dc640739a)(ctx, p.type === 'shield' ? 'S' : 'D', p.x + 12, p.y + 19, 18, '#080d23', 'center');
        }
        if (this.invincible <= 0 || Math.floor(this.time * 10) % 2 || reduced) {
            ctx.save();
            ctx.translate(this.player.x, this.player.y);
            ctx.fillStyle = '#f8b45b';
            ctx.fillRect(-5, 15, 10, 12 + Math.sin(this.time * 40) * 5);
            ctx.fillStyle = '#b6d9ff';
            ctx.beginPath();
            ctx.moveTo(0, -25);
            ctx.lineTo(23, 20);
            ctx.lineTo(0, 11);
            ctx.lineTo(-23, 20);
            ctx.closePath();
            ctx.fill();
            ctx.fillStyle = '#3e8bc9';
            ctx.fillRect(-4, -8, 8, 18);
            if (this.shield || this.invincible > 0) {
                ctx.strokeStyle = '#69deff';
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.arc(0, 0, 30, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.restore();
        }
        if (!reduced) for (const p of this.particles){
            ctx.globalAlpha = Math.max(0, p.life * 2);
            ctx.fillStyle = p.color;
            ctx.fillRect(p.x, p.y, 4, 4);
        }
        ctx.globalAlpha = 1;
        for (const p of this.popups)(0, $f07d147227763a00$export$1237798dc640739a)(ctx, p.text, (0, $f07d147227763a00$export$7d15b64cf5a3a4c4)(p.x, 80, 500), p.y, 16, '#a0ffcf', 'center');
        if (this.transition > 0 || this.bannerTime > 0) {
            ctx.fillStyle = '#080d23dd';
            ctx.fillRect(15, 310, 570, 66);
            (0, $f07d147227763a00$export$1237798dc640739a)(ctx, this.banner, 300, 350, 21, '#e2eaff', 'center');
        }
        if (this.double > 0) (0, $f07d147227763a00$export$1237798dc640739a)(ctx, `DOUBLE SHOT ${Math.ceil(this.double)}s`, 20, 688, 15, '#a0ffa5');
        if (this.shield) (0, $f07d147227763a00$export$1237798dc640739a)(ctx, 'SHIELD READY', 580, 688, 15, '#69deff', 'right');
    }
}



const $77679acc7598e824$var$TITLES = [
    'One quick search',
    'Untitled document',
    'Where is the music?',
    'You have won!',
    'Reply all (38)',
    'Another dashboard',
    'Lunch options',
    'Meeting about meetings',
    'Download (7).pdf',
    'Is the internet down?',
    'Sales follow-up #12',
    'New tab'
];
class $77679acc7598e824$export$c2cd7a4dd7340ee2 {
    constructor(random, finish){
        this.random = random;
        this.finish = finish;
        this.score = 0;
        this.level = 1;
        this.time = 0;
        this.ram = 15;
        this.combo = 0;
        this.bestCombo = 0;
        this.closed = 0;
        this.selected = 0;
        this.mistakes = 0;
        this.tabs = Array(12).fill(null);
        this.pinned = Math.floor(random() * 12);
        this.tabs[this.pinned] = {
            pinned: true,
            title: 'Actual work',
            age: 0
        };
        this.spawnTimer = 1.2;
        this.restoreTimer = 22;
        this.message = 'Keep the starred work tab. Close everything else.';
        this.messageTime = 4;
        this.lastClose = -10;
        this.over = false;
        this.flash = 0;
        this.protect = 0;
        for(let i = 0; i < 3; i++)this.spawn();
    }
    spawn() {
        const free = this.tabs.map((t, i)=>t ? -1 : i).filter((i)=>i >= 0);
        if (!free.length) {
            this.ram += 7;
            return;
        }
        const slot = free[Math.floor(this.random() * free.length)];
        this.tabs[slot] = {
            title: $77679acc7598e824$var$TITLES[Math.floor(this.random() * $77679acc7598e824$var$TITLES.length)],
            age: 0,
            noisy: this.random() < .2
        };
        this.ram += 2;
    }
    point(x, y) {
        const col = Math.floor((x - 18) / 190), row = Math.floor((y - 170) / 115);
        if (x < 18 || x > 582 || y < 170 || y > 616 || col > 2 || row > 3) return;
        if ((x - 18) % 190 > 184 || (y - 170) % 115 > 101) return;
        this.selected = row * 3 + col;
        this.close(this.selected);
    }
    key(key) {
        if (key === 'ArrowLeft' || key.toLowerCase() === 'a') this.selected = (this.selected + 11) % 12;
        if (key === 'ArrowRight' || key.toLowerCase() === 'd') this.selected = (this.selected + 1) % 12;
        if (key === 'ArrowUp' || key.toLowerCase() === 'w') this.selected = (this.selected + 9) % 12;
        if (key === 'ArrowDown' || key.toLowerCase() === 's') this.selected = (this.selected + 3) % 12;
        if (key === ' ' || key === 'Enter') this.close(this.selected);
    }
    close(index) {
        if (this.over) return;
        const tab = this.tabs[index];
        if (!tab) return;
        if (tab.pinned) {
            if (this.protect > 0) return;
            this.ram = Math.min(100, this.ram + 18);
            this.mistakes++;
            this.combo = 0;
            this.flash = .3;
            this.protect = 1;
            this.message = 'That was the work tab. Restored. +18 RAM.';
            this.messageTime = 2.5;
            (0, $f07d147227763a00$export$7297c25227171a1f)('hurt');
            return;
        }
        this.combo = this.time - this.lastClose < 2 ? this.combo + 1 : 1;
        this.lastClose = this.time;
        this.bestCombo = Math.max(this.combo, this.bestCombo);
        this.score += 50 * Math.min(5, Math.ceil(this.combo / 3));
        this.closed++;
        this.tabs[index] = null;
        this.ram = Math.max(0, this.ram - (tab.noisy ? 10 : 6));
        (0, $f07d147227763a00$export$7297c25227171a1f)(tab.noisy ? 'collect' : 'clear');
        if (this.closed % 15 === 0) {
            this.level++;
            this.score += 250;
            this.ram = Math.max(0, this.ram - 10);
            this.message = `Shift ${this.level} \u{2022} +250 \u{2022} Ed is opening more tabs.`;
            this.messageTime = 3;
            (0, $f07d147227763a00$export$7297c25227171a1f)('wave');
        }
    }
    update(dt) {
        if (this.over) return;
        this.time += dt;
        this.messageTime -= dt;
        this.flash -= dt;
        this.protect -= dt;
        let pressure = .65 + Math.min(2, this.level * .1);
        this.tabs.forEach((t)=>{
            if (t && !t.pinned) {
                t.age += dt;
                pressure += t.noisy ? 1.65 : .72;
            }
        });
        this.ram += dt * pressure;
        this.spawnTimer -= dt;
        this.restoreTimer -= dt;
        if (this.spawnTimer <= 0) {
            this.spawn();
            this.spawnTimer = Math.max(.32, 1.5 - this.level * .105);
        }
        if (this.restoreTimer <= 0) {
            this.spawn();
            this.spawn();
            this.spawn();
            this.message = 'Restore previous session? Ed already clicked yes.';
            this.messageTime = 3.5;
            this.restoreTimer = 22;
            (0, $f07d147227763a00$export$7297c25227171a1f)('wave');
        }
        if (this.ram >= 100) {
            this.ram = 100;
            this.over = true;
            this.finish({
                score: this.score,
                level: this.level,
                detail: `${this.closed} tabs closed \u{2022} ${Math.floor(this.time)} seconds \u{2022} best combo ${this.bestCombo}`,
                achievement: this.closed >= 50 && !this.mistakes ? 'Work tab guardian' : this.bestCombo >= 15 ? 'Tab terminator' : 'Session restored'
            });
        }
    }
    draw(ctx, reduced) {
        ctx.fillStyle = '#101a29';
        ctx.fillRect(0, 0, 600, 700);
        ctx.fillStyle = '#213049';
        ctx.fillRect(0, 0, 600, 52);
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, String(this.score).padStart(6, '0'), 20, 34, 23);
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, `SHIFT ${this.level}`, 580, 33, 18, '#b8c9e7', 'right');
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, 'RAM', 20, 83, 17, '#b8c9e7');
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, `${Math.ceil(this.ram)} / 100`, 580, 83, 17, this.ram > 75 ? '#ff8598' : '#98edda', 'right');
        ctx.fillStyle = '#2b3b52';
        ctx.fillRect(20, 96, 560, 17);
        ctx.fillStyle = this.ram > 75 ? '#ff6987' : '#6be2c4';
        ctx.fillRect(20, 96, 560 * (0, $f07d147227763a00$export$7d15b64cf5a3a4c4)(this.ram / 100, 0, 1), 17);
        (0, $f07d147227763a00$export$1237798dc640739a)(ctx, this.combo > 1 ? `${this.combo} COMBO \u{2022} ${Math.min(5, Math.ceil(this.combo / 3))}\xd7 POINTS` : "Close junk. Protect \u2605 Actual work.", 20, 148, 17, '#ffdf96');
        for(let i = 0; i < 12; i++){
            const x = 18 + i % 3 * 190, y = 170 + Math.floor(i / 3) * 115, t = this.tabs[i];
            ctx.fillStyle = t ? t.pinned ? '#253e42' : '#d8e4f0' : '#182639';
            ctx.fillRect(x, y, 184, 101);
            if (t) {
                ctx.fillStyle = t.pinned ? '#366665' : t.noisy ? '#b585ad' : '#aebfd6';
                ctx.fillRect(x, y, 184, 26);
                (0, $f07d147227763a00$export$1237798dc640739a)(ctx, t.pinned ? "\u2605 PINNED" : t.noisy ? "\u266B PLAYING AUDIO" : 'BROWSER TAB', x + 9, y + 18, 12, t.pinned ? '#c6fff1' : '#22324b');
                if (!t.pinned) (0, $f07d147227763a00$export$1237798dc640739a)(ctx, "\xd7", x + 172, y + 21, 25, '#25344d', 'right');
                const words = t.title.split(' ');
                let line = '', lines = [];
                words.forEach((word)=>{
                    if ((line + word).length > 17) {
                        lines.push(line);
                        line = '';
                    }
                    line += word + ' ';
                });
                lines.push(line);
                lines.forEach((l, j)=>(0, $f07d147227763a00$export$1237798dc640739a)(ctx, l.trim(), x + 10, y + 51 + j * 18, 15, t.pinned ? '#d9fff4' : '#22324b'));
                (0, $f07d147227763a00$export$1237798dc640739a)(ctx, t.pinned ? 'Do not close' : 'Tap to close', x + 10, y + 89, 12, t.pinned ? '#92cabc' : '#52647d');
            } else (0, $f07d147227763a00$export$1237798dc640739a)(ctx, '+', x + 92, y + 59, 24, '#3f526b', 'center');
            if (i === this.selected) {
                ctx.strokeStyle = '#ffd784';
                ctx.lineWidth = 3;
                ctx.strokeRect(x - 2, y - 2, 188, 105);
            }
        }
        const message = this.messageTime > 0 ? this.message : `${this.closed} tabs closed. ${Math.floor(this.time)}s without a browser crash.`;
        const words = message.split(' ');
        let line = '', lines = [];
        words.forEach((word)=>{
            if ((line + word).length > 49) {
                lines.push(line);
                line = '';
            }
            line += word + ' ';
        });
        lines.push(line);
        lines.forEach((l, i)=>(0, $f07d147227763a00$export$1237798dc640739a)(ctx, l.trim(), 300, 652 + i * 22, 17, '#c5d3e8', 'center'));
        if (this.flash > 0 && !reduced) {
            ctx.fillStyle = '#ff456522';
            ctx.fillRect(0, 0, 600, 700);
        }
    }
}



// Tiny 3x5 lettering and integer rectangles keep the art crisp at every resolution.
const $77f0448333f5540c$var$FONT = {
    A: '010101111101101',
    B: '110101110101110',
    C: '011100100100011',
    D: '110101101101110',
    E: '111100110100111',
    F: '111100110100100',
    G: '011100101101011',
    H: '101101111101101',
    I: '111010010010111',
    J: '001001001101010',
    K: '101101110101101',
    L: '100100100100111',
    M: '101111111101101',
    N: '101111111111101',
    O: '010101101101010',
    P: '110101110100100',
    Q: '010101101111011',
    R: '110101110101101',
    S: '011100010001110',
    T: '111010010010010',
    U: '101101101101111',
    V: '101101101101010',
    W: '101101111111101',
    X: '101101010101101',
    Y: '101101010010010',
    Z: '111001010100111',
    '0': '111101101101111',
    '1': '010110010010111',
    '2': '110001010100111',
    '3': '110001010001110',
    '4': '101101111001001',
    '5': '111100110001110',
    '6': '011100111101111',
    '7': '111001010010010',
    '8': '111101111101111',
    '9': '111101111001110',
    ':': '000010000010000',
    '!': '010010010000010',
    '.': '000000000000010',
    '+': '000010111010000',
    '-': '000000111000000',
    '/': '001001010100100',
    '%': '101001010100101',
    "'": '010010000000000',
    '?': '110001010000010'
};
function $77f0448333f5540c$var$rect(c, x, y, w, h, color) {
    c.fillStyle = color;
    c.fillRect(Math.round(x), Math.round(y), w, h);
}
function $77f0448333f5540c$var$text(c, value, x, y, color = '#f9edc8', scale = 1, align = 'left') {
    const s = String(value).toUpperCase(), width = (s.length * 4 - 1) * scale;
    if (align === 'center') x -= width / 2;
    if (align === 'right') x -= width;
    for(let i = 0; i < s.length; i++){
        const glyph = $77f0448333f5540c$var$FONT[s[i]];
        if (!glyph) continue;
        for(let p = 0; p < 15; p++)if (glyph[p] === '1') $77f0448333f5540c$var$rect(c, x + (i * 4 + p % 3) * scale, y + Math.floor(p / 3) * scale, scale, scale, color);
    }
}
function $77f0448333f5540c$var$office(c) {
    $77f0448333f5540c$var$rect(c, 37, 52, 232, 62, '#4b594d');
    $77f0448333f5540c$var$rect(c, 30, 45, 240, 62, '#b2b3a0');
    $77f0448333f5540c$var$rect(c, 30, 45, 240, 5, '#e6ddbd');
    $77f0448333f5540c$var$rect(c, 30, 67, 240, 4, '#d3cdb3');
    $77f0448333f5540c$var$rect(c, 30, 94, 240, 4, '#d3cdb3');
    for (const y of [
        54,
        79
    ])for(let x = 38; x < 263; x += 19){
        $77f0448333f5540c$var$rect(c, x, y, 15, 12, '#334d59');
        $77f0448333f5540c$var$rect(c, x + 1, y + 1, 13, 3, '#638383');
        $77f0448333f5540c$var$rect(c, x + 9, y + 4, 2, 8, '#9aac9e');
    }
    $77f0448333f5540c$var$rect(c, 121, 43, 58, 64, '#ddd6bb');
    $77f0448333f5540c$var$rect(c, 132, 53, 36, 54, '#889084');
    $77f0448333f5540c$var$rect(c, 139, 56, 22, 51, '#314957');
    $77f0448333f5540c$var$rect(c, 149, 57, 2, 49, '#c7c6ad');
    $77f0448333f5540c$var$rect(c, 126, 47, 6, 60, '#eee4c8');
    $77f0448333f5540c$var$rect(c, 168, 47, 6, 60, '#eee4c8');
    $77f0448333f5540c$var$rect(c, 129, 104, 42, 4, '#f0e7cd');
    $77f0448333f5540c$var$rect(c, 125, 108, 50, 4, '#bdbbab');
    $77f0448333f5540c$var$rect(c, 121, 112, 58, 3, '#e2ddc4');
    $77f0448333f5540c$var$rect(c, 33, 98, 40, 6, '#d0cbb4');
    $77f0448333f5540c$var$text(c, 'OFFICE PARK', 36, 99, '#4b554c');
}
function $77f0448333f5540c$var$tree(c, x, y) {
    $77f0448333f5540c$var$rect(c, x + 5, y + 10, 19, 9, '#315038');
    $77f0448333f5540c$var$rect(c, x + 11, y + 3, 4, 17, '#806146');
    $77f0448333f5540c$var$rect(c, x + 2, y - 7, 23, 18, '#2e583d');
    $77f0448333f5540c$var$rect(c, x - 1, y - 2, 29, 8, '#386e43');
    $77f0448333f5540c$var$rect(c, x + 5, y - 13, 16, 9, '#4e8048');
    $77f0448333f5540c$var$rect(c, x + 8, y - 15, 8, 6, '#69924f');
    $77f0448333f5540c$var$rect(c, x + 3, y - 1, 7, 4, '#759c50');
    $77f0448333f5540c$var$rect(c, x + 16, y - 7, 5, 5, '#406e40');
}
function $77f0448333f5540c$var$car(c, car, time, reduced) {
    const { x: x, y: y, color: color } = car, nudge = !reduced && car.honk > 0 ? Math.sin(time * 60) * 1.5 : 0;
    c.save();
    c.translate(Math.round(x + nudge), y);
    $77f0448333f5540c$var$rect(c, -8, -12, 20, 31, '#242e30');
    $77f0448333f5540c$var$rect(c, -11, -12, 3, 7, '#202c30');
    $77f0448333f5540c$var$rect(c, 8, -12, 3, 7, '#202c30');
    $77f0448333f5540c$var$rect(c, -11, 8, 3, 7, '#202c30');
    $77f0448333f5540c$var$rect(c, 8, 8, 3, 7, '#202c30');
    $77f0448333f5540c$var$rect(c, -9, -17, 18, 34, color);
    $77f0448333f5540c$var$rect(c, -7, -15, 14, 3, '#ffffff65');
    $77f0448333f5540c$var$rect(c, -7, -9, 14, 7, '#304b5a');
    $77f0448333f5540c$var$rect(c, -6, -8, 12, 2, '#7ca9ae');
    $77f0448333f5540c$var$rect(c, -6, 9, 12, 4, '#304b5a');
    $77f0448333f5540c$var$rect(c, -8, -17, 4, 2, '#fff2b9');
    $77f0448333f5540c$var$rect(c, 4, -17, 4, 2, '#fff2b9');
    $77f0448333f5540c$var$rect(c, -8, 15, 4, 2, '#e67363');
    $77f0448333f5540c$var$rect(c, 4, 15, 4, 2, '#e67363');
    if (car.rock) {
        $77f0448333f5540c$var$rect(c, 2, -13, 3, 2, '#e4e4d1');
        $77f0448333f5540c$var$rect(c, 3, -11, 1, 2, '#39434a');
    }
    if (car.dirt) for(let i = 0; i < 7; i++)$77f0448333f5540c$var$rect(c, -7 + i * 2, -6 + i % 3 * 4, 4, 3, '#b69866');
    if (car.honk > 0) $77f0448333f5540c$var$text(c, 'HONK!', 0, -27, '#ffe5a1', 1, 'center');
    c.restore();
}
function $77f0448333f5540c$var$ninja(c, g, reduced, tool) {
    const p = g.player, x = Math.round(p.x), y = Math.round(p.y);
    const bob = !reduced && g.moving ? Math.floor(g.time * 12) % 2 : 0;
    $77f0448333f5540c$var$rect(c, x - 8, y + 5, 17, 4, '#24432f66');
    if (g.tool === 2) {
        $77f0448333f5540c$var$rect(c, x - 11, y - 6, 22, 17, '#d3ad48');
        $77f0448333f5540c$var$rect(c, x - 13, y - 4, 4, 6, '#26313a');
        $77f0448333f5540c$var$rect(c, x + 9, y - 4, 4, 6, '#26313a');
        $77f0448333f5540c$var$rect(c, x - 13, y + 6, 4, 6, '#26313a');
        $77f0448333f5540c$var$rect(c, x + 9, y + 6, 4, 6, '#26313a');
        $77f0448333f5540c$var$rect(c, x - 7, y + 4, 14, 7, '#f1ce69');
        $77f0448333f5540c$var$rect(c, x - 5, y + 1, 10, 3, '#71833d');
    }
    $77f0448333f5540c$var$rect(c, x - 5, y - 7 - bob, 10, 12, '#263743');
    $77f0448333f5540c$var$rect(c, x - 5, y - 15 - bob, 10, 10, '#263743');
    $77f0448333f5540c$var$rect(c, x - 4, y - 12 - bob, 8, 4, '#eac59a');
    $77f0448333f5540c$var$rect(c, x - 2, y - 11 - bob, 1, 1, '#1a2835');
    $77f0448333f5540c$var$rect(c, x + 2, y - 11 - bob, 1, 1, '#1a2835');
    $77f0448333f5540c$var$rect(c, x - 6, y - 15 - bob, 12, 3, tool.color);
    $77f0448333f5540c$var$rect(c, x + 5, y - 15 - bob, 6, 2, tool.color);
    $77f0448333f5540c$var$rect(c, x + 9, y - 14 - bob, 3, 4, tool.color);
    $77f0448333f5540c$var$rect(c, x - 5, y - 2, 10, 2, tool.color);
    if (g.tool !== 2) {
        $77f0448333f5540c$var$rect(c, x - 5, y + 3, 4, 4 + bob, '#1b2935');
        $77f0448333f5540c$var$rect(c, x + 1, y + 3, 4, 5 - bob, '#1b2935');
    }
    const tx = Math.round(x + p.dx * 19), ty = Math.round(y + p.dy * (p.dy < 0 ? 25 : 17));
    if (g.tool === 0 || g.tool === 3) {
        c.strokeStyle = '#b5bfac';
        c.lineWidth = 2;
        c.beginPath();
        c.moveTo(x + 4, y - 3);
        c.lineTo(tx, ty);
        c.stroke();
        $77f0448333f5540c$var$rect(c, tx - 3, ty - 2, 6, 4, g.tool === 0 ? '#e27c47' : '#293f4b');
        if (g.tool === 3) $77f0448333f5540c$var$rect(c, x - 8, y - 7, 5, 9, '#a281bc');
        if (g.working && !reduced) for(let i = 0; i < 4; i++){
            const offset = (g.time * 60 + i * 7) % 22;
            $77f0448333f5540c$var$rect(c, tx + p.dx * offset + (i % 2 * 3 - 1), ty + p.dy * offset, 2, 2, tool.color);
        }
    } else if (g.tool === 1) {
        c.strokeStyle = '#b9c2ad';
        c.lineWidth = 2;
        c.beginPath();
        c.moveTo(x, y);
        c.lineTo(tx, ty);
        c.stroke();
        $77f0448333f5540c$var$rect(c, tx - 7, ty - 5, 14, 11, '#5bb4bc');
        $77f0448333f5540c$var$rect(c, tx - 4, ty - 3, 8, 6, '#388080');
        for (const a of [
            -8,
            6
        ]){
            $77f0448333f5540c$var$rect(c, tx + a, ty - 5, 3, 4, '#26313a');
            $77f0448333f5540c$var$rect(c, tx + a, ty + 3, 3, 4, '#26313a');
        }
    }
}
function $77f0448333f5540c$export$b46375f857d81e75(c, g, reduced, tools, lawns) {
    c.save();
    c.scale(2, 2);
    c.imageSmoothingEnabled = false;
    $77f0448333f5540c$var$rect(c, 0, 0, 300, 350, '#253c3c');
    $77f0448333f5540c$var$rect(c, 0, 0, 300, 39, '#1d3034');
    $77f0448333f5540c$var$rect(c, 0, 39, 300, 3, '#dacb84');
    $77f0448333f5540c$var$text(c, 'LAWN NINJAS', 10, 8, '#eff0b5', 2);
    $77f0448333f5540c$var$text(c, `SHIFT ${g.level}`, 290, 10, '#91c9b1', 1, 'right');
    $77f0448333f5540c$var$text(c, String(g.score).padStart(6, '0'), 10, 25, '#f7d782');
    $77f0448333f5540c$var$text(c, `${Math.ceil(g.remaining)} SEC`, 290, 24, g.remaining < 15 ? '#ff9472' : '#f4edcc', 1, 'right');
    $77f0448333f5540c$var$rect(c, 91, 26, 100, 4, '#41584d');
    $77f0448333f5540c$var$rect(c, 91, 26, Math.round(100 * (g.progress || 0)), 4, '#b0d65d');
    $77f0448333f5540c$var$text(c, `${Math.floor((g.progress || 0) * 100)}% CLEAN`, 141, 33, '#bad1b2', 1, 'center');
    $77f0448333f5540c$var$rect(c, 0, 42, 300, 277, '#7f9b54');
    $77f0448333f5540c$var$rect(c, 5, 116, 290, 13, '#d1ccae');
    $77f0448333f5540c$var$rect(c, 132, 115, 36, 118, '#d1ccae');
    $77f0448333f5540c$var$rect(c, 7, 214, 286, 17, '#e0d8bb');
    $77f0448333f5540c$var$rect(c, 7, 214, 286, 2, '#f0e7cd');
    $77f0448333f5540c$var$rect(c, 68, 233, 164, 74, '#747b71');
    $77f0448333f5540c$var$rect(c, 68, 233, 164, 2, '#d1ccae');
    for(let x = 68; x < 234; x += 41){
        $77f0448333f5540c$var$rect(c, x, 249, 2, 51, '#d8d3a9');
        $77f0448333f5540c$var$rect(c, x, 298, 41, 2, '#d8d3a9');
    }
    $77f0448333f5540c$var$rect(c, 5, 307, 290, 11, '#bdbb9e');
    for (const lawn of lawns){
        $77f0448333f5540c$var$rect(c, lawn.x - 2, lawn.y - 2, lawn.w + 4, lawn.h + 4, '#496c3e');
        $77f0448333f5540c$var$rect(c, lawn.x, lawn.y, lawn.w, lawn.h, '#83ae4d');
        for(let y = lawn.y; y < lawn.y + lawn.h; y += 12)$77f0448333f5540c$var$rect(c, lawn.x, y, lawn.w, 6, '#91b852');
    }
    for (const j of g.jobs){
        if (j.kind === 'grass') {
            if (!j.done) {
                $77f0448333f5540c$var$rect(c, j.x - 3, j.y - 2, 1, 5, '#496f38');
                $77f0448333f5540c$var$rect(c, j.x - 2, j.y + 1, 4, 2, '#507c39');
                $77f0448333f5540c$var$rect(c, j.x + 2, j.y - 4, 1, 6, '#537b39');
            } else $77f0448333f5540c$var$rect(c, j.x - 5, j.y + 2, 9, 1, '#bad478');
        } else if (j.kind === 'edge') {
            if (!j.done) for(let i = 0; i < 5; i++)$77f0448333f5540c$var$rect(c, j.x - 5 + i * 3, j.y - (i % 2 ? 3 : 5), 2, 7, '#345d37');
        } else if (j.kind === 'bush') {
            $77f0448333f5540c$var$rect(c, j.x - 9, j.y - 5, 20, 8, '#315139');
            $77f0448333f5540c$var$rect(c, j.x - 9, j.y - (j.done ? 8 : 11), 18, j.done ? 9 : 13, j.done ? '#66954b' : '#416f3b');
            $77f0448333f5540c$var$rect(c, j.x - 7, j.y - (j.done ? 8 : 11), 14, 3, j.done ? '#9fbd66' : '#709449');
            if (!j.done) {
                $77f0448333f5540c$var$rect(c, j.x - 12, j.y - 6, 4, 4, '#416f3b');
                $77f0448333f5540c$var$rect(c, j.x + 6, j.y - 14, 4, 7, '#416f3b');
            }
        } else if (!j.done && j.kind === 'leaves') for(let i = 0; i < 9; i++)$77f0448333f5540c$var$rect(c, j.x - 7 + i * 7 % 14, j.y - 3 + i * 3 % 8, 4, 2, [
            '#d99843',
            '#edd275',
            '#a76d39'
        ][i % 3]);
        else if (!j.done && j.kind === 'dirt') {
            $77f0448333f5540c$var$rect(c, j.x - 5, j.y, 11, 4, '#96734b');
            $77f0448333f5540c$var$rect(c, j.x - 3, j.y - 2, 7, 3, '#bb9460');
        }
        if (!j.done && j.work > 0) {
            $77f0448333f5540c$var$rect(c, j.x - 6, j.y + 8, 12, 2, '#233d38');
            $77f0448333f5540c$var$rect(c, j.x - 6, j.y + 8, Math.min(12, j.work * 26), 2, '#ffe49a');
        }
    }
    for (const stone of g.stones)if (!stone.used) {
        $77f0448333f5540c$var$rect(c, stone.x - 2, stone.y, 5, 3, '#e1ddc1');
        $77f0448333f5540c$var$rect(c, stone.x, stone.y - 1, 2, 1, '#fbf0cb');
    }
    $77f0448333f5540c$var$office(c);
    $77f0448333f5540c$var$tree(c, 3, 87);
    $77f0448333f5540c$var$tree(c, 268, 87);
    for (const a of g.cars)$77f0448333f5540c$var$car(c, a, g.time, reduced);
    $77f0448333f5540c$var$ninja(c, g, reduced, tools[g.tool]);
    if (!reduced) for (const p of g.particles)$77f0448333f5540c$var$rect(c, p.x, p.y, 2, 2, p.color);
    for (const s of g.shots)if (s.kind === 'dirt') {
        $77f0448333f5540c$var$rect(c, s.x - 5, s.y - 3, 9, 6, '#c7a879');
        $77f0448333f5540c$var$rect(c, s.x - 2, s.y - 5, 5, 10, '#b49465');
    } else $77f0448333f5540c$var$rect(c, s.x - 1, s.y - 1, 3, 3, '#f9edcc');
    for (const p of g.popups)$77f0448333f5540c$var$text(c, p.text, Math.max(45, Math.min(250, p.x)), p.y, p.color, 1, 'center');
    $77f0448333f5540c$var$rect(c, 0, 319, 300, 31, '#1d3034');
    $77f0448333f5540c$var$rect(c, 0, 319, 300, 2, '#dacb84');
    const tool = tools[g.tool];
    $77f0448333f5540c$var$text(c, `${g.tool + 1} ${tool.name}`, 9, 326, tool.color);
    $77f0448333f5540c$var$text(c, `CAR BONUS ${g.mischief}`, 290, 326, '#f6db91', 1, 'right');
    const msg = g.messageTime > 0 ? g.message : 'MOW GRASS. TRIM HEDGES. BLOW LEAVES + DIRT.';
    $77f0448333f5540c$var$text(c, msg, 150, 339, '#c1d5b1', 1, 'center');
    c.restore();
}


const $a42a8e306f173625$export$5cb8d3433e7f4f3f = [
    {
        name: 'Weed eater',
        short: 'TRIM',
        color: '#ef8755',
        speed: 64,
        range: 19,
        kinds: [
            'edge',
            'bush'
        ]
    },
    {
        name: 'Push mower',
        short: 'MOW',
        color: '#70cbd3',
        speed: 61,
        range: 15,
        kinds: [
            'grass'
        ]
    },
    {
        name: 'Riding mower',
        short: 'RIDE',
        color: '#f1ce69',
        speed: 96,
        range: 23,
        kinds: [
            'grass'
        ]
    },
    {
        name: 'Leaf blower',
        short: 'BLOW',
        color: '#bc9ae8',
        speed: 67,
        range: 26,
        kinds: [
            'leaves',
            'dirt'
        ]
    }
];
const $a42a8e306f173625$export$5b51ef9ee48373b9 = [
    {
        x: 15,
        y: 132,
        w: 112,
        h: 78
    },
    {
        x: 173,
        y: 132,
        w: 112,
        h: 78
    },
    {
        x: 15,
        y: 234,
        w: 48,
        h: 72
    },
    {
        x: 237,
        y: 234,
        w: 48,
        h: 72
    }
];
const $a42a8e306f173625$var$POINTS = {
    grass: 10,
    edge: 30,
    bush: 100,
    leaves: 80,
    dirt: 50
};
const $a42a8e306f173625$var$WORK = {
    grass: .04,
    edge: .16,
    bush: .45,
    leaves: .32,
    dirt: .25
};
const $a42a8e306f173625$var$distance = (a, b)=>Math.hypot(a.x - b.x, a.y - b.y);
class $a42a8e306f173625$export$43e3affd235a3370 {
    constructor(random, finish){
        this.random = random;
        this.finish = finish;
        this.level = 1;
        this.score = 0;
        this.time = 0;
        this.cleaned = 0;
        this.mischief = 0;
        this.over = false;
        this.tool = 1;
        this.player = {
            x: 150,
            y: 220,
            dx: 0,
            dy: -1
        };
        this.particles = [];
        this.popups = [];
        this.shots = [];
        this.workSound = 0;
        this.newShift();
    }
    newShift() {
        this.remaining = Math.max(60, 110 - this.level * 8);
        this.jobs = [];
        this.stones = [];
        this.shots = [];
        this.particles = [];
        for (const lawn of $a42a8e306f173625$export$5b51ef9ee48373b9){
            for(let y = lawn.y + 8; y < lawn.y + lawn.h - 3; y += 12)for(let x = lawn.x + 8; x < lawn.x + lawn.w - 3; x += 12)this.jobs.push({
                kind: 'grass',
                x: x,
                y: y,
                done: false,
                work: 0
            });
            for(let x = lawn.x + 10; x < lawn.x + lawn.w; x += 32)this.jobs.push({
                kind: 'edge',
                x: x,
                y: lawn.y + lawn.h - 2,
                done: false,
                work: 0
            });
        }
        for (const x of [
            29,
            68,
            107,
            193,
            232,
            271
        ])this.jobs.push({
            kind: 'bush',
            x: x,
            y: 123,
            done: false,
            work: 0
        });
        for(let i = 0; i < 6; i++){
            const lawn = $a42a8e306f173625$export$5b51ef9ee48373b9[i % $a42a8e306f173625$export$5b51ef9ee48373b9.length];
            this.jobs.push({
                kind: 'leaves',
                x: lawn.x + 12 + this.random() * (lawn.w - 24),
                y: lawn.y + 18 + this.random() * (lawn.h - 35),
                done: false,
                work: 0
            });
        }
        this.cars = [
            88,
            129,
            171,
            212
        ].map((x, i)=>({
                x: x,
                y: 271,
                color: [
                    '#c65a55',
                    '#e1c66b',
                    '#6d98bb',
                    '#d4d4c1'
                ][i],
                rock: false,
                dirt: false,
                honk: 0
            }));
        for (const car of this.cars){
            this.jobs.push({
                kind: 'dirt',
                x: car.x + 8,
                y: 238,
                done: false,
                work: 0
            });
            this.stones.push({
                x: car.x - 6,
                y: 243,
                used: false
            });
        }
        this.totalJobs = this.jobs.length;
        this.player.x = 150;
        this.player.y = 220;
        this.message = this.level === 1 ? 'LOOK SHARP. LEAVE THE CARS QUESTIONABLE.' : `SHIFT ${this.level}! THE GRASS GREW BACK.`;
        this.messageTime = 4;
        this.progress = 0;
    }
    selectTool(index) {
        if (Number.isInteger(index) && $a42a8e306f173625$export$5cb8d3433e7f4f3f[index]) this.tool = index;
    }
    blocked(x, y) {
        if (x < 10 || x > 290 || y < 116 || y > 310) return true;
        return this.cars.some((c)=>Math.abs(x - c.x) < 16 && Math.abs(y - c.y) < 23);
    }
    popup(text, x, y, color = '#fff2a8') {
        this.popups.push({
            text: text,
            x: x,
            y: y,
            color: color,
            life: 1.3
        });
    }
    burst(x, y, color, count = 6) {
        // Decorative particles use fixed directions, never the daily gameplay RNG.
        for(let i = 0; i < count; i++){
            const angle = i * 2.399 + this.time;
            this.particles.push({
                x: x,
                y: y,
                vx: Math.cos(angle) * 23,
                vy: Math.sin(angle) * 23 - 10,
                life: .4,
                color: color
            });
        }
    }
    hitCar(car, kind) {
        if (car[kind]) return;
        car[kind] = true;
        car.honk = .7;
        this.mischief++;
        const points = kind === 'rock' ? 150 : 200;
        this.score += points;
        this.popup(`${kind === 'rock' ? 'PING' : 'DUSTED'} +${points}`, car.x, car.y - 23, '#ffe483');
        this.message = kind === 'rock' ? 'CUSTOM PAINT JOB! +150' : 'COMPLIMENTARY DIRT DETAIL! +200';
        this.messageTime = 2.2;
        (0, $f07d147227763a00$export$7297c25227171a1f)('hit');
        this.burst(car.x, car.y, kind === 'rock' ? '#e5e3cd' : '#bd9068');
    }
    launch(kind, x, y) {
        this.shots.push({
            kind: kind,
            x: x,
            y: y,
            vx: this.player.dx * 145,
            vy: this.player.dy * 145,
            life: 1.1
        });
    }
    work(dt) {
        const tool = $a42a8e306f173625$export$5cb8d3433e7f4f3f[this.tool], player = this.player;
        for (const job of this.jobs){
            if (job.done || !tool.kinds.includes(job.kind) || $a42a8e306f173625$var$distance(player, job) > tool.range) continue;
            job.work += dt;
            if (job.work < $a42a8e306f173625$var$WORK[job.kind]) continue;
            job.done = true;
            this.cleaned++;
            this.score += $a42a8e306f173625$var$POINTS[job.kind];
            if (job.kind !== 'grass') this.popup(`+${$a42a8e306f173625$var$POINTS[job.kind]}`, job.x, job.y - 7);
            this.burst(job.x, job.y, job.kind === 'leaves' ? '#df9c4b' : '#c6e579', 4);
            if (job.kind === 'dirt') this.launch('dirt', job.x, job.y);
            if (this.workSound <= 0) {
                (0, $f07d147227763a00$export$7297c25227171a1f)('clear');
                this.workSound = .16;
            }
        }
        // Pebbles only fly toward the parking lot, so touch drags past them don't waste the shot.
        if (this.tool !== 3 && player.dy > .7) {
            for (const stone of this.stones)if (!stone.used && $a42a8e306f173625$var$distance(player, stone) < tool.range) {
                stone.used = true;
                this.launch('rock', stone.x, stone.y);
                (0, $f07d147227763a00$export$7297c25227171a1f)('shot');
            }
        }
    }
    update(dt, input) {
        if (this.over) return;
        this.time += dt;
        this.remaining -= dt;
        this.messageTime -= dt;
        this.workSound -= dt;
        if (this.remaining <= 0) {
            this.remaining = 0;
            this.over = true;
            this.finish({
                score: this.score,
                level: this.level,
                detail: `${this.cleaned} jobs cleaned up \u{2022} ${this.mischief} car bonuses \u{2022} shift ${this.level}`,
                achievement: this.mischief >= 6 ? 'Parking lot menace' : this.level > 1 ? 'Master of the mow' : this.cleaned > 30 ? 'Grass assassin' : 'Apprentice of the lawn'
            });
            return;
        }
        const p = this.player;
        let dx = Number(!!input.right) - Number(!!input.left), dy = Number(!!input.down) - Number(!!input.up);
        if (input.pointer && input.targetX != null && input.targetY != null) {
            const tx = input.targetX / 2 - p.x, ty = input.targetY / 2 - p.y;
            const gap = Math.hypot(tx, ty);
            if (gap > 2) {
                dx = tx / gap;
                dy = ty / gap;
            }
        }
        const length = Math.hypot(dx, dy);
        this.moving = length > 0;
        if (length) {
            dx /= length;
            dy /= length;
            p.dx = dx;
            p.dy = dy;
            const speed = $a42a8e306f173625$export$5cb8d3433e7f4f3f[this.tool].speed * dt;
            if (!this.blocked(p.x + dx * speed, p.y)) p.x += dx * speed;
            if (!this.blocked(p.x, p.y + dy * speed)) p.y += dy * speed;
        }
        this.working = !!(input.shoot || input.pointer);
        if (this.working) this.work(dt);
        for (const shot of this.shots){
            shot.x += shot.vx * dt;
            shot.y += shot.vy * dt;
            shot.life -= dt;
            const car = this.cars.find((c)=>Math.abs(shot.x - c.x) < 12 && Math.abs(shot.y - c.y) < 18);
            if (car && shot.life > 0) {
                this.hitCar(car, shot.kind);
                shot.life = 0;
            }
        }
        this.shots = this.shots.filter((s)=>s.life > 0);
        for (const car of this.cars)car.honk = Math.max(0, car.honk - dt);
        for (const particle of this.particles){
            particle.x += particle.vx * dt;
            particle.y += particle.vy * dt;
            particle.life -= dt;
        }
        this.particles = this.particles.filter((particle)=>particle.life > 0);
        for (const popup of this.popups){
            popup.y -= dt * 10;
            popup.life -= dt;
        }
        this.popups = this.popups.filter((popup)=>popup.life > 0);
        this.progress = this.jobs.filter((j)=>j.done).length / this.totalJobs;
        // Let in-flight pebbles and dirt land before the lot resets.
        if (this.progress === 1 && !this.shots.length) {
            const bonus = 500 + Math.ceil(this.remaining) * 10;
            this.score += bonus;
            this.level++;
            this.popup(`SHIFT CLEAR +${bonus}`, 150, 215);
            this.newShift();
            (0, $f07d147227763a00$export$7297c25227171a1f)('wave');
        }
    }
    draw(ctx, reduced) {
        (0, $77f0448333f5540c$export$b46375f857d81e75)(ctx, this, reduced, $a42a8e306f173625$export$5cb8d3433e7f4f3f, $a42a8e306f173625$export$5b51ef9ee48373b9);
    }
}




const $c3a9b968ea1563a7$var$GAMES = {
    shooter: {
        name: 'Galaga',
        subtitle: 'Deep-space defense',
        description: 'Break formations. Dodge diving attackers. Take on the flagship.',
        instructions: "Move with \u2190 \u2192 or A / D. Hold Space to fire. On touch, drag your ship to move and fire. Catch D for double shot and S for a shield.",
        badge: 'The original, upgraded',
        Class: (0, $c1b0f4343ba38314$export$33fe5d76f4f0235c)
    },
    tabs: {
        name: 'Tabageddon',
        subtitle: 'Browser survival',
        description: 'Ed opened every tab. You have one browser and very little RAM.',
        instructions: "Tap junk tabs to close them. Keep \u2605 Actual work open. On keyboard, select with arrow keys or WASD and close with Space. Close quickly for combos. Audio tabs use extra RAM.",
        badge: 'New arrival',
        Class: (0, $77679acc7598e824$export$c2cd7a4dd7340ee2)
    },
    lawn: {
        name: 'Lawn Ninjas',
        subtitle: 'Groundskeeping. Questionable ethics.',
        description: 'The office lawns need a hero. The parking lot needs better insurance. Clean up the grounds before your shift ends, then do it all again.',
        instructions: "Move with arrows or WASD. Hold Space to work. Switch tools with 1\u20134 or the tool buttons: weed eater trims bushes and edges, mowers cut grass, blower clears leaves and dirt. On touch, drag on the grounds to move and work. Face a car while kicking a pebble or blowing a dirt pile for bonus points. Each car pays once per bonus type per shift.",
        badge: "New \u2022 Lawn enforcement",
        Class: (0, $a42a8e306f173625$export$43e3affd235a3370)
    }
};
let $c3a9b968ea1563a7$var$dialog, $c3a9b968ea1563a7$var$frame, $c3a9b968ea1563a7$var$game, $c3a9b968ea1563a7$var$state = 'lobby', $c3a9b968ea1563a7$var$input = {}, $c3a9b968ea1563a7$var$selection = 'shooter', $c3a9b968ea1563a7$var$daily = false, $c3a9b968ea1563a7$var$runDate, $c3a9b968ea1563a7$var$previousFocus, $c3a9b968ea1563a7$var$last = 0, $c3a9b968ea1563a7$var$accumulator = 0, $c3a9b968ea1563a7$var$result;
let $c3a9b968ea1563a7$var$records = (0, $f07d147227763a00$export$aafa59e2e03f2942)('ed-arcade-v1', {});
if (!$c3a9b968ea1563a7$var$records || typeof $c3a9b968ea1563a7$var$records !== 'object' || Array.isArray($c3a9b968ea1563a7$var$records)) $c3a9b968ea1563a7$var$records = {};
const $c3a9b968ea1563a7$var$reduced = matchMedia('(prefers-reduced-motion: reduce)');
let $c3a9b968ea1563a7$var$canvas, $c3a9b968ea1563a7$var$ctx, $c3a9b968ea1563a7$var$panel, $c3a9b968ea1563a7$var$stage, $c3a9b968ea1563a7$var$hud, $c3a9b968ea1563a7$var$live;
const $c3a9b968ea1563a7$var$$ = (s)=>$c3a9b968ea1563a7$var$dialog.querySelector(s);
function $c3a9b968ea1563a7$var$recordKey() {
    return $c3a9b968ea1563a7$var$daily ? `${$c3a9b968ea1563a7$var$selection}:${$c3a9b968ea1563a7$var$runDate}` : $c3a9b968ea1563a7$var$selection;
}
function $c3a9b968ea1563a7$var$best(key) {
    return Number($c3a9b968ea1563a7$var$records[key]?.score) || 0;
}
function $c3a9b968ea1563a7$var$clearInput() {
    $c3a9b968ea1563a7$var$input = {
        left: false,
        right: false,
        up: false,
        down: false,
        shoot: false,
        pointer: false,
        targetX: null,
        targetY: null
    };
}
function $c3a9b968ea1563a7$var$button(text, action, cls = '') {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.textContent = text;
    b.addEventListener('click', action);
    return b;
}
function $c3a9b968ea1563a7$var$announce(text) {
    $c3a9b968ea1563a7$var$live.textContent = text;
}
function $c3a9b968ea1563a7$var$updateSound() {
    if ($c3a9b968ea1563a7$var$dialog) {
        const b = $c3a9b968ea1563a7$var$$('[data-sound]');
        b.textContent = (0, $f07d147227763a00$export$589e67d858c44a42)() ? 'Sound off' : 'Sound on';
        b.setAttribute('aria-pressed', String(!(0, $f07d147227763a00$export$589e67d858c44a42)()));
    }
}
function $c3a9b968ea1563a7$var$title(text, sub) {
    const p = document.createElement('p');
    p.className = 'arcade-kicker';
    p.textContent = sub;
    const h = document.createElement('h2');
    h.textContent = text;
    $c3a9b968ea1563a7$var$panel.append(p, h);
}
function $c3a9b968ea1563a7$var$paragraph(text) {
    const p = document.createElement('p');
    p.textContent = text;
    $c3a9b968ea1563a7$var$panel.append(p);
}
function $c3a9b968ea1563a7$var$controls() {
    const el = document.createElement('div');
    el.className = 'arcade-actions';
    $c3a9b968ea1563a7$var$panel.append(el);
    return el;
}
function $c3a9b968ea1563a7$var$showPanel(mode) {
    $c3a9b968ea1563a7$var$$('[data-instructions]').textContent = '';
    $c3a9b968ea1563a7$var$$('[data-lawn-controls]').hidden = true;
    $c3a9b968ea1563a7$var$state = mode;
    $c3a9b968ea1563a7$var$clearInput();
    $c3a9b968ea1563a7$var$panel.replaceChildren();
    $c3a9b968ea1563a7$var$panel.hidden = false;
    $c3a9b968ea1563a7$var$hud.hidden = true;
    $c3a9b968ea1563a7$var$stage.classList.toggle('arcade-stage--lobby', mode === 'lobby');
}
function $c3a9b968ea1563a7$var$playControls() {
    $c3a9b968ea1563a7$var$$('[data-instructions]').textContent = $c3a9b968ea1563a7$var$selection === 'shooter' ? "\u2190 \u2192 / A D move \xb7 Space fires \xb7 Touch: drag to fly & fire" : $c3a9b968ea1563a7$var$selection === 'lawn' ? "Arrows / WASD move \xb7 Hold Space to work \xb7 1\u20134 tools \xb7 Touch: drag to move & work" : "Tap tabs to close \xb7 Arrows / WASD select \xb7 Space closes";
    $c3a9b968ea1563a7$var$$('[data-lawn-controls]').hidden = $c3a9b968ea1563a7$var$selection !== 'lawn';
    if ($c3a9b968ea1563a7$var$selection === 'lawn') $c3a9b968ea1563a7$var$syncTools();
}
function $c3a9b968ea1563a7$var$syncTools() {
    $c3a9b968ea1563a7$var$dialog.querySelectorAll('[data-tool]').forEach((b, i)=>b.setAttribute('aria-pressed', String(i === $c3a9b968ea1563a7$var$game?.tool)));
}
function $c3a9b968ea1563a7$var$lobby() {
    $c3a9b968ea1563a7$var$game = null;
    $c3a9b968ea1563a7$var$showPanel('lobby');
    $c3a9b968ea1563a7$var$canvas.hidden = true;
    delete $c3a9b968ea1563a7$var$dialog.dataset.game;
    $c3a9b968ea1563a7$var$title('After Hours Arcade', '215 recreation division');
    $c3a9b968ea1563a7$var$paragraph('Three cabinets. No quarters. Productivity has left the building.');
    const cards = document.createElement('div');
    cards.className = 'arcade-cabinets';
    for (const [id, data] of Object.entries($c3a9b968ea1563a7$var$GAMES)){
        const card = $c3a9b968ea1563a7$var$button('', ()=>$c3a9b968ea1563a7$var$briefing(id), `arcade-cabinet arcade-cabinet--${id}`);
        card.innerHTML = `<span class="cabinet-badge">${data.badge}</span><span class="cabinet-screen" aria-hidden="true">${id === 'shooter' ? '<span class="pixel-enemies">\u265F \u265F \u265F<br>\u265F \u265F \u265F</span><span class="pixel-ship">\u25B2</span>' : '<span class="mini-tabs">\xd7 &nbsp; \xd7 &nbsp; \xd7<br>\xd7 &nbsp; \u2605 &nbsp; \xd7<br>\xd7 &nbsp; \xd7 &nbsp; \xd7</span>'}</span><strong>${data.name}</strong><span>${data.subtitle}</span><span class="cabinet-best">Personal best ${$c3a9b968ea1563a7$var$best(id).toLocaleString()}</span><span class="cabinet-play">Select game</span>`;
        if (id === 'lawn') {
            const preview = document.createElement('canvas');
            preview.width = 600;
            preview.height = 700;
            preview.className = 'cabinet-lawn-art';
            const previewCtx = preview.getContext('2d'); // Decorative; keep the text cabinet art if a context is unavailable.
            if (previewCtx) {
                new (0, $a42a8e306f173625$export$43e3affd235a3370)((0, $f07d147227763a00$export$b53e1522c5b09138)('lawn-cabinet'), ()=>{}).draw(previewCtx, true);
                card.querySelector('.cabinet-screen').replaceChildren(preview);
            }
        }
        cards.append(card);
    }
    $c3a9b968ea1563a7$var$panel.append(cards);
    const footer = document.createElement('p');
    footer.className = 'arcade-small';
    footer.textContent = 'Records and discoveries stay in this browser. Free play forever.';
    $c3a9b968ea1563a7$var$panel.append(footer);
    cards.querySelector('button').focus();
    $c3a9b968ea1563a7$var$announce('Arcade lobby. Choose Galaga, Tabageddon, or Lawn Ninjas.');
}
function $c3a9b968ea1563a7$var$briefing(id) {
    $c3a9b968ea1563a7$var$selection = id;
    $c3a9b968ea1563a7$var$game = null;
    $c3a9b968ea1563a7$var$showPanel('ready');
    $c3a9b968ea1563a7$var$canvas.hidden = true;
    $c3a9b968ea1563a7$var$dialog.dataset.game = id;
    const data = $c3a9b968ea1563a7$var$GAMES[id];
    $c3a9b968ea1563a7$var$title(data.name, data.subtitle);
    $c3a9b968ea1563a7$var$paragraph(data.description);
    $c3a9b968ea1563a7$var$paragraph(data.instructions);
    const badges = $c3a9b968ea1563a7$var$records[id]?.achievements;
    if (Array.isArray(badges) && badges.length) $c3a9b968ea1563a7$var$paragraph(`Earned: ${badges.join(" \u2022 ")}`);
    const actions = $c3a9b968ea1563a7$var$controls();
    actions.append($c3a9b968ea1563a7$var$button('Start game', ()=>$c3a9b968ea1563a7$var$start(false), 'arcade-primary'), $c3a9b968ea1563a7$var$button('Daily challenge', ()=>$c3a9b968ea1563a7$var$start(true)), $c3a9b968ea1563a7$var$button('Choose another game', $c3a9b968ea1563a7$var$lobby));
    $c3a9b968ea1563a7$var$paragraph('Daily challenge: the same starting seed for everyone today (UTC). A separate personal best is saved. P pauses; Esc opens the pause menu.');
    actions.firstChild.focus();
}
function $c3a9b968ea1563a7$var$start(isDaily) {
    $c3a9b968ea1563a7$var$daily = isDaily;
    $c3a9b968ea1563a7$var$runDate = new Date().toISOString().slice(0, 10);
    $c3a9b968ea1563a7$var$result = null;
    $c3a9b968ea1563a7$var$clearInput();
    (0, $f07d147227763a00$export$3f66b274a2143589)();
    const rng = (0, $f07d147227763a00$export$b53e1522c5b09138)($c3a9b968ea1563a7$var$daily ? `${$c3a9b968ea1563a7$var$selection}:${$c3a9b968ea1563a7$var$runDate}` : `${Date.now()}:${Math.random()}`);
    $c3a9b968ea1563a7$var$game = new $c3a9b968ea1563a7$var$GAMES[$c3a9b968ea1563a7$var$selection].Class(rng, $c3a9b968ea1563a7$var$finish);
    $c3a9b968ea1563a7$var$state = 'playing';
    $c3a9b968ea1563a7$var$accumulator = 0;
    $c3a9b968ea1563a7$var$last = 0;
    $c3a9b968ea1563a7$var$panel.hidden = true;
    $c3a9b968ea1563a7$var$canvas.hidden = false;
    $c3a9b968ea1563a7$var$hud.hidden = false;
    $c3a9b968ea1563a7$var$stage.classList.remove('arcade-stage--lobby');
    $c3a9b968ea1563a7$var$$('[data-game-title]').textContent = `${$c3a9b968ea1563a7$var$GAMES[$c3a9b968ea1563a7$var$selection].name}${$c3a9b968ea1563a7$var$daily ? " \u2022 Daily" : ''}`;
    $c3a9b968ea1563a7$var$playControls();
    $c3a9b968ea1563a7$var$canvas.setAttribute('aria-label', `${$c3a9b968ea1563a7$var$GAMES[$c3a9b968ea1563a7$var$selection].name}. ${$c3a9b968ea1563a7$var$GAMES[$c3a9b968ea1563a7$var$selection].instructions}`);
    $c3a9b968ea1563a7$var$canvas.focus();
    (0, $f07d147227763a00$export$4c0029b0ace0292a)($c3a9b968ea1563a7$var$selection === 'tabs' ? 'tabs' : 'arcade');
    $c3a9b968ea1563a7$var$announce(`${$c3a9b968ea1563a7$var$GAMES[$c3a9b968ea1563a7$var$selection].name} started.`);
}
function $c3a9b968ea1563a7$var$pause() {
    if ($c3a9b968ea1563a7$var$state !== 'playing' || !$c3a9b968ea1563a7$var$dialog?.open || !$c3a9b968ea1563a7$var$game) return;
    $c3a9b968ea1563a7$var$showPanel('paused');
    $c3a9b968ea1563a7$var$title('Take a breather.', 'Game paused');
    $c3a9b968ea1563a7$var$paragraph('Your run is right where you left it.');
    const actions = $c3a9b968ea1563a7$var$controls();
    actions.append($c3a9b968ea1563a7$var$button('Resume game', $c3a9b968ea1563a7$var$resume, 'arcade-primary'), $c3a9b968ea1563a7$var$button('Restart run', ()=>$c3a9b968ea1563a7$var$start($c3a9b968ea1563a7$var$daily)), $c3a9b968ea1563a7$var$button('Back to arcade', $c3a9b968ea1563a7$var$lobby));
    actions.firstChild.focus();
    $c3a9b968ea1563a7$var$announce('Game paused.');
}
function $c3a9b968ea1563a7$var$resume() {
    if ($c3a9b968ea1563a7$var$state !== 'paused') return;
    $c3a9b968ea1563a7$var$state = 'playing';
    $c3a9b968ea1563a7$var$panel.hidden = true;
    $c3a9b968ea1563a7$var$hud.hidden = false;
    $c3a9b968ea1563a7$var$playControls();
    $c3a9b968ea1563a7$var$clearInput();
    $c3a9b968ea1563a7$var$accumulator = 0;
    $c3a9b968ea1563a7$var$last = 0;
    $c3a9b968ea1563a7$var$canvas.focus();
}
function $c3a9b968ea1563a7$var$finish(value) {
    $c3a9b968ea1563a7$var$result = value;
    const key = $c3a9b968ea1563a7$var$recordKey(), oldBest = $c3a9b968ea1563a7$var$best(key);
    const previous = $c3a9b968ea1563a7$var$records[key] || {};
    const achievements = [
        ...new Set([
            ...Array.isArray(previous.achievements) ? previous.achievements : [],
            value.achievement
        ])
    ];
    $c3a9b968ea1563a7$var$records[key] = {
        score: Math.max(oldBest, value.score),
        achievements: achievements
    }; // Keep free-play and daily records separate.
    const dailyKeys = Object.keys($c3a9b968ea1563a7$var$records).filter((k)=>k.includes(':')).sort();
    dailyKeys.slice(0, Math.max(0, dailyKeys.length - 60)).forEach((k)=>delete $c3a9b968ea1563a7$var$records[k]);
    (0, $f07d147227763a00$export$a1544dad697b423d)('ed-arcade-v1', $c3a9b968ea1563a7$var$records);
    $c3a9b968ea1563a7$var$showPanel('over');
    $c3a9b968ea1563a7$var$canvas.hidden = true;
    $c3a9b968ea1563a7$var$title($c3a9b968ea1563a7$var$selection === 'tabs' ? 'Browser not responding.' : $c3a9b968ea1563a7$var$selection === 'lawn' ? 'Clocking out. Ninja style.' : 'Flight complete.', value.score > oldBest ? 'New personal best' : 'Run complete');
    const score = document.createElement('strong');
    score.className = 'arcade-result-score';
    score.textContent = value.score.toLocaleString();
    $c3a9b968ea1563a7$var$panel.append(score);
    $c3a9b968ea1563a7$var$paragraph(value.detail);
    $c3a9b968ea1563a7$var$paragraph(`Achievement: ${value.achievement}`);
    $c3a9b968ea1563a7$var$paragraph(`Personal best: ${$c3a9b968ea1563a7$var$best(key).toLocaleString()}${$c3a9b968ea1563a7$var$daily ? ` \u{2022} ${$c3a9b968ea1563a7$var$runDate} daily` : ''}`);
    const actions = $c3a9b968ea1563a7$var$controls();
    actions.append($c3a9b968ea1563a7$var$button('Play again', ()=>$c3a9b968ea1563a7$var$start($c3a9b968ea1563a7$var$daily), 'arcade-primary'), $c3a9b968ea1563a7$var$button('Share score', ()=>{}), $c3a9b968ea1563a7$var$button('Back to arcade', $c3a9b968ea1563a7$var$lobby));
    const share = actions.children[1];
    share.addEventListener('click', async ()=>{
        const ok = await (0, $f07d147227763a00$export$c8531afc97e1e0f8)(`${$c3a9b968ea1563a7$var$GAMES[$c3a9b968ea1563a7$var$selection].name}: ${value.score.toLocaleString()} points${$c3a9b968ea1563a7$var$daily ? ` in the ${$c3a9b968ea1563a7$var$runDate} daily challenge` : ''}. ${value.achievement}. Your turn: https://whatswrongwithed.com/#arcade`);
        share.textContent = ok ? 'Score copied!' : "Could not copy \u2014 try again";
        share.focus();
    });
    actions.firstChild.focus();
    $c3a9b968ea1563a7$var$announce(`Game over. ${value.score} points. ${value.achievement}.`);
}
function $c3a9b968ea1563a7$var$tick(now) {
    if (!$c3a9b968ea1563a7$var$dialog?.open) return;
    if ($c3a9b968ea1563a7$var$state === 'playing' && $c3a9b968ea1563a7$var$game) {
        if ($c3a9b968ea1563a7$var$last) $c3a9b968ea1563a7$var$accumulator += Math.min((now - $c3a9b968ea1563a7$var$last) / 1000, .1);
        while($c3a9b968ea1563a7$var$accumulator >= 1 / 60 && $c3a9b968ea1563a7$var$state === 'playing'){
            $c3a9b968ea1563a7$var$game.update(1 / 60, $c3a9b968ea1563a7$var$input);
            $c3a9b968ea1563a7$var$accumulator -= 1 / 60;
        }
    } else $c3a9b968ea1563a7$var$accumulator = 0;
    $c3a9b968ea1563a7$var$last = now;
    if ($c3a9b968ea1563a7$var$game && !$c3a9b968ea1563a7$var$canvas.hidden) $c3a9b968ea1563a7$var$game.draw($c3a9b968ea1563a7$var$ctx, $c3a9b968ea1563a7$var$reduced.matches);
    $c3a9b968ea1563a7$var$frame = requestAnimationFrame($c3a9b968ea1563a7$var$tick);
}
function $c3a9b968ea1563a7$var$keydown(e) {
    if (!$c3a9b968ea1563a7$var$dialog.open) return;
    const k = e.code === 'Space' ? ' ' : e.key;
    if (k === 'Escape') {
        e.preventDefault();
        if (e.repeat) return;
        if ($c3a9b968ea1563a7$var$state === 'playing') $c3a9b968ea1563a7$var$pause();
        else if ($c3a9b968ea1563a7$var$state === 'paused') $c3a9b968ea1563a7$var$resume();
        else $c3a9b968ea1563a7$var$dialog.close();
        return;
    }
    if (/^p$/i.test(k) && !e.repeat) {
        if ($c3a9b968ea1563a7$var$state === 'playing') $c3a9b968ea1563a7$var$pause();
        else if ($c3a9b968ea1563a7$var$state === 'paused') $c3a9b968ea1563a7$var$resume();
        return;
    }
    if ($c3a9b968ea1563a7$var$state !== 'playing') return;
    if ([
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        ' ',
        'Enter',
        'a',
        'A',
        'd',
        'D',
        'w',
        'W',
        's',
        'S'
    ].includes(k)) e.preventDefault();
    if ($c3a9b968ea1563a7$var$selection === 'tabs') {
        if (!e.repeat || k !== ' ' && k !== 'Enter') $c3a9b968ea1563a7$var$game.key(k);
        return;
    }
    if ($c3a9b968ea1563a7$var$selection === 'lawn') {
        if (/^[1-4]$/.test(k)) {
            $c3a9b968ea1563a7$var$game.selectTool(Number(k) - 1);
            $c3a9b968ea1563a7$var$syncTools();
            e.preventDefault();
        }
        if (k === 'ArrowUp' || /^w$/i.test(k)) {
            $c3a9b968ea1563a7$var$input.up = true;
            $c3a9b968ea1563a7$var$input.targetX = $c3a9b968ea1563a7$var$input.targetY = null;
        }
        if (k === 'ArrowDown' || /^s$/i.test(k)) {
            $c3a9b968ea1563a7$var$input.down = true;
            $c3a9b968ea1563a7$var$input.targetX = $c3a9b968ea1563a7$var$input.targetY = null;
        }
    }
    if (k === 'ArrowLeft' || /^a$/i.test(k)) {
        $c3a9b968ea1563a7$var$input.left = true;
        $c3a9b968ea1563a7$var$input.targetX = null;
    }
    if (k === 'ArrowRight' || /^d$/i.test(k)) {
        $c3a9b968ea1563a7$var$input.right = true;
        $c3a9b968ea1563a7$var$input.targetX = null;
    }
    if (k === ' ' || $c3a9b968ea1563a7$var$selection === 'shooter' && k === 'ArrowUp') $c3a9b968ea1563a7$var$input.shoot = true;
}
function $c3a9b968ea1563a7$var$makeDialog() {
    $c3a9b968ea1563a7$var$dialog = document.createElement('dialog');
    $c3a9b968ea1563a7$var$dialog.className = 'arcade-dialog';
    $c3a9b968ea1563a7$var$dialog.setAttribute('aria-label', 'After Hours Arcade');
    $c3a9b968ea1563a7$var$dialog.innerHTML = `<div class="arcade-shell"><header class="arcade-top"><span>215 / AFTER HOURS</span><div><button type="button" data-sound></button><button type="button" data-close aria-label="Close arcade">Close \u{2715}</button></div></header><div class="arcade-hud" hidden><strong data-game-title></strong><button type="button" data-pause>Pause</button></div><div class="arcade-stage"><canvas width="600" height="700" tabindex="0"></canvas><section class="arcade-panel"></section></div><div class="lawn-tools" data-lawn-controls role="group" aria-label="Lawn care equipment" hidden></div><p class="arcade-instructions" data-instructions></p><p class="sr-only" aria-live="polite" data-live></p></div>`;
    document.body.append($c3a9b968ea1563a7$var$dialog);
    $c3a9b968ea1563a7$var$canvas = $c3a9b968ea1563a7$var$$('canvas');
    $c3a9b968ea1563a7$var$ctx = $c3a9b968ea1563a7$var$canvas.getContext('2d');
    $c3a9b968ea1563a7$var$panel = $c3a9b968ea1563a7$var$$('.arcade-panel');
    $c3a9b968ea1563a7$var$stage = $c3a9b968ea1563a7$var$$('.arcade-stage');
    $c3a9b968ea1563a7$var$hud = $c3a9b968ea1563a7$var$$('.arcade-hud');
    $c3a9b968ea1563a7$var$live = $c3a9b968ea1563a7$var$$('[data-live]');
    $c3a9b968ea1563a7$var$$('[data-close]').addEventListener('click', ()=>$c3a9b968ea1563a7$var$dialog.close());
    $c3a9b968ea1563a7$var$$('[data-pause]').addEventListener('click', $c3a9b968ea1563a7$var$pause);
    $c3a9b968ea1563a7$var$$('[data-sound]').addEventListener('click', ()=>{
        (0, $f07d147227763a00$export$a1680ba91cc9be33)(!(0, $f07d147227763a00$export$589e67d858c44a42)());
        $c3a9b968ea1563a7$var$updateSound();
    });
    (0, $a42a8e306f173625$export$5cb8d3433e7f4f3f).forEach((tool, i)=>{
        const b = $c3a9b968ea1563a7$var$button(`${i + 1} ${tool.name}`, ()=>{
            if ($c3a9b968ea1563a7$var$state === 'playing' && $c3a9b968ea1563a7$var$selection === 'lawn') {
                $c3a9b968ea1563a7$var$game.selectTool(i);
                $c3a9b968ea1563a7$var$syncTools();
                $c3a9b968ea1563a7$var$canvas.focus();
            }
        });
        b.dataset.tool = String(i);
        b.style.setProperty('--tool-color', tool.color);
        b.setAttribute('aria-pressed', 'false');
        $c3a9b968ea1563a7$var$$('[data-lawn-controls]').append(b);
    });
    $c3a9b968ea1563a7$var$dialog.addEventListener('cancel', (e)=>{
        e.preventDefault();
        if ($c3a9b968ea1563a7$var$state === 'playing') $c3a9b968ea1563a7$var$pause();
        else $c3a9b968ea1563a7$var$dialog.close();
    });
    $c3a9b968ea1563a7$var$dialog.addEventListener('keydown', $c3a9b968ea1563a7$var$keydown);
    $c3a9b968ea1563a7$var$dialog.addEventListener('keyup', (e)=>{
        if (e.key === 'ArrowLeft' || /^a$/i.test(e.key)) $c3a9b968ea1563a7$var$input.left = false;
        if (e.key === 'ArrowRight' || /^d$/i.test(e.key)) $c3a9b968ea1563a7$var$input.right = false;
        if (e.key === 'ArrowUp' || /^w$/i.test(e.key)) $c3a9b968ea1563a7$var$input.up = false;
        if (e.key === 'ArrowDown' || /^s$/i.test(e.key)) $c3a9b968ea1563a7$var$input.down = false;
        if (e.code === 'Space' || e.key === ' ' || $c3a9b968ea1563a7$var$selection === 'shooter' && e.key === 'ArrowUp') $c3a9b968ea1563a7$var$input.shoot = false;
    });
    const coords = (e)=>{
        const r = $c3a9b968ea1563a7$var$canvas.getBoundingClientRect();
        return {
            x: (e.clientX - r.left) * 600 / r.width,
            y: (e.clientY - r.top) * 700 / r.height
        };
    };
    $c3a9b968ea1563a7$var$canvas.addEventListener('pointerdown', (e)=>{
        if ($c3a9b968ea1563a7$var$state !== 'playing' || e.pointerType === 'mouse' && e.button !== 0) return;
        e.preventDefault();
        $c3a9b968ea1563a7$var$canvas.focus();
        $c3a9b968ea1563a7$var$canvas.setPointerCapture(e.pointerId);
        const p = coords(e);
        if ($c3a9b968ea1563a7$var$selection === 'tabs') $c3a9b968ea1563a7$var$game.point(p.x, p.y);
        else {
            $c3a9b968ea1563a7$var$input.targetX = p.x;
            $c3a9b968ea1563a7$var$input.targetY = p.y;
            $c3a9b968ea1563a7$var$input.pointer = true;
        }
    });
    $c3a9b968ea1563a7$var$canvas.addEventListener('pointermove', (e)=>{
        if ($c3a9b968ea1563a7$var$state === 'playing' && $c3a9b968ea1563a7$var$selection !== 'tabs' && $c3a9b968ea1563a7$var$input.pointer) {
            const p = coords(e);
            $c3a9b968ea1563a7$var$input.targetX = p.x;
            $c3a9b968ea1563a7$var$input.targetY = p.y;
        }
    });
    [
        'pointerup',
        'pointercancel',
        'lostpointercapture'
    ].forEach((event)=>$c3a9b968ea1563a7$var$canvas.addEventListener(event, ()=>{
            $c3a9b968ea1563a7$var$input.pointer = false;
            $c3a9b968ea1563a7$var$input.targetX = $c3a9b968ea1563a7$var$input.targetY = null;
        }));
    $c3a9b968ea1563a7$var$dialog.addEventListener('close', ()=>{
        cancelAnimationFrame($c3a9b968ea1563a7$var$frame);
        $c3a9b968ea1563a7$var$game = null;
        $c3a9b968ea1563a7$var$state = 'lobby';
        $c3a9b968ea1563a7$var$clearInput();
        window.galagaGameActive = false;
        document.body.classList.remove('arcade-open');
        $c3a9b968ea1563a7$var$previousFocus?.focus();
    });
    document.addEventListener('visibilitychange', ()=>{
        if (document.hidden) $c3a9b968ea1563a7$var$pause();
    });
    window.addEventListener('blur', $c3a9b968ea1563a7$var$pause);
    document.addEventListener('ed-sound-change', $c3a9b968ea1563a7$var$updateSound);
}
function $c3a9b968ea1563a7$export$fda4df29dd45d459() {
    if (!$c3a9b968ea1563a7$var$dialog) $c3a9b968ea1563a7$var$makeDialog();
    if ($c3a9b968ea1563a7$var$dialog.open) return;
    $c3a9b968ea1563a7$var$previousFocus = document.activeElement;
    (0, $f07d147227763a00$export$f29aa9650e04f442)();
    window.galagaGameActive = true;
    document.body.classList.add('arcade-open');
    $c3a9b968ea1563a7$var$dialog.showModal();
    $c3a9b968ea1563a7$var$updateSound();
    $c3a9b968ea1563a7$var$lobby();
    $c3a9b968ea1563a7$var$last = 0;
    $c3a9b968ea1563a7$var$frame = requestAnimationFrame($c3a9b968ea1563a7$var$tick);
}





const $8df1547c7cba1307$var$DISCOVERIES = {
    redacted: [
        'Clearance granted',
        'The subject has been found unfit for duty. Shocking.'
    ],
    monkey: [
        'Unsupervised',
        'Surveillance confirms: nobody is in charge.'
    ],
    chuckles: [
        'Known associate',
        'Chuckles has declined to comment. Repeatedly.'
    ],
    footage: [
        'Caught on tape',
        'The evidence speaks for itself. Unfortunately.'
    ],
    complaint: [
        'Paper trail',
        'Your complaint has joined a very long queue.'
    ],
    lever: [
        'Declassified',
        'The division regrets giving you a lever.'
    ],
    arcade: [
        'Off the clock',
        'Training hours have been reclassified as recreation.'
    ],
    tabs: [
        'Browser intervention',
        'Chrome would like to thank you for your service.'
    ]
};
function $8df1547c7cba1307$export$43ad82df239a300c() {
    const saved = (0, $f07d147227763a00$export$aafa59e2e03f2942)('ed-discoveries-v1', []);
    const found = new Set(Array.isArray(saved) ? saved.filter((id)=>Object.hasOwn($8df1547c7cba1307$var$DISCOVERIES, id)) : []);
    const progress = document.getElementById('discovery-progress'), stamps = document.getElementById('discovery-stamps'), note = document.getElementById('discovery-note');
    const render = ()=>{
        progress.textContent = `${found.size} / ${Object.keys($8df1547c7cba1307$var$DISCOVERIES).length} discoveries`;
        stamps.replaceChildren();
        for (const [id, [name]] of Object.entries($8df1547c7cba1307$var$DISCOVERIES)){
            const li = document.createElement('li');
            li.textContent = found.has(id) ? `\u{2713} ${name}` : "\u25B0 Classified";
            li.classList.toggle('is-found', found.has(id));
            stamps.append(li);
        }
        if (found.size === 8) {
            note.textContent = 'OMEGA CLEARANCE GRANTED. All evidence recovered. Ed remains unsupervised.';
            note.classList.add('clearance-complete');
        }
    };
    render();
    document.addEventListener('ed-discover', (e)=>{
        const id = e.detail;
        if (!Object.hasOwn($8df1547c7cba1307$var$DISCOVERIES, id) || found.has(id)) return;
        found.add(id);
        (0, $f07d147227763a00$export$a1544dad697b423d)('ed-discoveries-v1', [
            ...found
        ]);
        note.textContent = $8df1547c7cba1307$var$DISCOVERIES[id][1];
        render();
        document.getElementById('dossier-status').textContent = `Evidence discovered: ${$8df1547c7cba1307$var$DISCOVERIES[id][0]}`;
    });
    const redact = document.querySelector('.redacted');
    const reveal = ()=>{
        redact.classList.add('is-revealed');
        document.dispatchEvent(new CustomEvent('ed-discover', {
            detail: 'redacted'
        }));
    };
    redact.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            reveal();
        }
    });
    redact.addEventListener('click', reveal);
    redact.addEventListener('focus', reveal);
    redact.addEventListener('mouseenter', reveal);
    const sound = document.getElementById('sound-toggle');
    const renderSound = ()=>{
        sound.textContent = (0, $f07d147227763a00$export$589e67d858c44a42)() ? 'Sound off' : 'Sound on';
        sound.setAttribute('aria-pressed', String(!(0, $f07d147227763a00$export$589e67d858c44a42)()));
        document.querySelectorAll('audio').forEach((a)=>a.muted = (0, $f07d147227763a00$export$589e67d858c44a42)());
    };
    sound.addEventListener('click', ()=>(0, $f07d147227763a00$export$a1680ba91cc9be33)(!(0, $f07d147227763a00$export$589e67d858c44a42)()));
    document.addEventListener('ed-sound-change', renderSound);
    renderSound();
    document.getElementById('stop-sound').addEventListener('click', ()=>{
        (0, $f07d147227763a00$export$f29aa9650e04f442)();
        document.getElementById('dossier-status').textContent = 'Surveillance audio stopped.';
    });
    document.getElementById('arcade-launch').addEventListener('click', (0, $c3a9b968ea1563a7$export$fda4df29dd45d459));
    document.querySelector('[data-open-arcade]').addEventListener('click', (0, $c3a9b968ea1563a7$export$fda4df29dd45d459));
    const share = document.getElementById('share-report');
    share.addEventListener('click', async ()=>{
        const count = document.getElementById('issue-count').textContent;
        const ok = await (0, $f07d147227763a00$export$c8531afc97e1e0f8)(`CONFIDENTIAL \u{2022} Case #215: What's Wrong With Ed?
${count} documented findings. Threat level: CRITICAL. Days without incident: 0.\n${found.size}/8 discoveries recovered.\nRead the dossier (and visit the arcade): https://whatswrongwithed.com/`);
        document.getElementById('dossier-status').textContent = ok ? 'Classified report copied. Distribute irresponsibly.' : 'Could not copy. Share whatswrongwithed.com instead.';
        share.textContent = ok ? "Report copied \u2713" : 'Try copying again';
        share.focus();
        setTimeout(()=>share.textContent = 'Copy classified report', 3000);
    });
}


var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}






// ============================================================================
// CONSTANTS
// ============================================================================
const $77ac944da51b7354$var$CLICK_CONFETTI = 5; // random confetti burst
const $77ac944da51b7354$var$CLICK_STARS = 10; // star confetti + monkey spin
const $77ac944da51b7354$var$CLICK_CANNONS = 15; // side-cannon confetti
const $77ac944da51b7354$var$CLICK_PARTY = 20; // full party mode (resets counter)
const $77ac944da51b7354$var$ACTIVE_PULSE_MS = 300;
const $77ac944da51b7354$var$DANCE_MS = 1000;
const $77ac944da51b7354$var$PULSE_MS = 500;
const $77ac944da51b7354$var$DAYS_COUNTER_INTERVAL_MS = 5000;
// Party mode: the visuals used to run for 4.5 min (a units bug). Keep it short.
const $77ac944da51b7354$var$PARTY_DURATION_MS = 12000;
const $77ac944da51b7354$var$TITLE_FLASH_MS = 5000;
const $77ac944da51b7354$var$CONFETTI_BURST_MS = 5000;
const $77ac944da51b7354$var$CONFETTI_REPEAT_MS = 5000;
const $77ac944da51b7354$var$CONFETTI_COLORS = [
    '#FFE400',
    '#FFBD00',
    '#E89400',
    '#FFCA6C',
    '#FDFFB8',
    '#a786ff',
    '#fd8bbc',
    '#eca184',
    '#f8deb1'
];
const $77ac944da51b7354$var$FUNNY_ITEMS = [
    {
        "text": "Opens a new tab to look for the tab he just opened",
        "severity": "extreme"
    },
    {
        "text": "Schedules a meeting to find out why there are so many meetings",
        "severity": "high"
    },
    {
        "text": "Has a strategic partnership with the snooze button",
        "severity": "critical"
    },
    {
        "text": "Treats the office like a drive-through",
        "severity": "high"
    },
    {
        "text": "His 30-minute workday includes a 25-minute warm-up",
        "severity": "extreme"
    },
    {
        "text": "Says \u201Cquick question\u201D and clears the afternoon",
        "severity": "high"
    },
    {
        "text": "Accepted a sales demo while trying to unsubscribe",
        "severity": "critical"
    },
    {
        "text": "Has 47 urgent emails marked as unread for later",
        "severity": "extreme"
    },
    {
        "text": "The follow-up needs a follow-up",
        "severity": "high"
    },
    {
        "text": "Calls it gas-lamping. Investigation ongoing.",
        "severity": "extreme"
    },
    {
        "text": "Replied \u201Csounds good\u201D without opening the attachment",
        "severity": "high"
    },
    {
        "text": "Chrome asked HIM to restore its previous session",
        "severity": "critical"
    },
    {
        "text": "Listed \u201Cavailable\u201D as a theoretical status",
        "severity": "medium"
    },
    {
        "text": "Put the task on a list of lists to make",
        "severity": "high"
    },
    {
        "text": "Went on mute. Spiritually. For the whole meeting.",
        "severity": "extreme"
    },
    {
        "text": "His calendar and reality are no longer on speaking terms",
        "severity": "critical"
    },
    {
        "text": "The sales rep has him listed as an emergency contact",
        "severity": "high"
    },
    {
        "text": "Says \u201Clet me circle back\u201D from an undisclosed location",
        "severity": "medium"
    }
];
let $77ac944da51b7354$var$complaintDeck = [];
const $77ac944da51b7354$var$KONAMI_CODE = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a'
];
// Tiny base64 blip reused for list-item hover feedback.
const $77ac944da51b7354$var$HOVER_SOUND_SRC = 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhDC16yetu1E0';
// ============================================================================
// LAZY-LOADED EFFECT LIBRARIES
// ============================================================================
let $77ac944da51b7354$var$confettiModulePromise = null;
let $77ac944da51b7354$var$balloonsModulePromise = null;

function $77ac944da51b7354$var$loadConfetti() {
    if (!$77ac944da51b7354$var$confettiModulePromise) $77ac944da51b7354$var$confettiModulePromise = (parcelRequire("RJkEF")).then((m)=>m.default || m);
    return $77ac944da51b7354$var$confettiModulePromise;
}

async function $77ac944da51b7354$var$triggerBalloonsAnimation() {
    if ($77ac944da51b7354$var$isReducedMotion) return;
    try {
        if (!$77ac944da51b7354$var$balloonsModulePromise) $77ac944da51b7354$var$balloonsModulePromise = (parcelRequire("cJ4SL"));
        const mod = await $77ac944da51b7354$var$balloonsModulePromise;
        const fn = mod.balloons || mod.default?.balloons || mod.default;
        if (typeof fn === 'function') fn();
        else throw new Error('balloons function not found in module');
    } catch  {
        $77ac944da51b7354$var$createProfessionalBalloons();
    }
}
// ============================================================================
// DOM ELEMENTS & ENVIRONMENT
// ============================================================================
const $77ac944da51b7354$var$monkeyImage = document.getElementById('monkey');
const $77ac944da51b7354$var$chucklesImage = document.getElementById('chuckles');
const $77ac944da51b7354$var$chucklesAudio = document.getElementById('chuckles-audio'); // clown.mp3 — plays for the Chuckles exhibit
const $77ac944da51b7354$var$fiestaAudio = document.getElementById('fiesta'); // fiesta.mp3 — plays for the monkey exhibit
const $77ac944da51b7354$var$isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $77ac944da51b7354$var$isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
let $77ac944da51b7354$var$clickCount = 0;
let $77ac944da51b7354$var$cursorRotation = 0;
let $77ac944da51b7354$var$partyActive = false;
let $77ac944da51b7354$var$partyModeType = 'confetti'; // cycles: 'confetti' -> 'balloons' -> 'rainbow'
function $77ac944da51b7354$var$scaleParticles(base) {
    if ($77ac944da51b7354$var$isReducedMotion) return 0;
    return Math.max(5, Math.round(base * ($77ac944da51b7354$var$isMobileViewport ? 0.5 : 1)));
}
function $77ac944da51b7354$var$playFiestaAudio() {
    if (!$77ac944da51b7354$var$fiestaAudio) return;
    $77ac944da51b7354$var$fiestaAudio.muted = (0, $f07d147227763a00$export$589e67d858c44a42)();
    $77ac944da51b7354$var$fiestaAudio.currentTime = 0;
    $77ac944da51b7354$var$fiestaAudio.play().catch(()=>{});
}
// Make the findings dance whenever the Chuckles audio plays.
if ($77ac944da51b7354$var$chucklesAudio) $77ac944da51b7354$var$chucklesAudio.addEventListener('play', ()=>{
    document.querySelectorAll('#ed-list li').forEach((li, index)=>{
        setTimeout(()=>{
            li.classList.add('dance');
            setTimeout(()=>li.classList.remove('dance'), $77ac944da51b7354$var$DANCE_MS);
        }, index * 100);
    });
});
// ============================================================================
// PAGE INITIALIZATION
// ============================================================================
document.addEventListener('DOMContentLoaded', ()=>{
    $77ac944da51b7354$var$initListItems();
    $77ac944da51b7354$var$initKonamiCode();
    $77ac944da51b7354$var$initMonkey();
    $77ac944da51b7354$var$initChuckles();
    $77ac944da51b7354$var$initAddItem();
    $77ac944da51b7354$var$initDaysCounter();
    $77ac944da51b7354$var$initCursorRotation();
    $77ac944da51b7354$var$initGalagaButton();
    $77ac944da51b7354$var$initLeverSwitch();
    (0, $8df1547c7cba1307$export$43ad82df239a300c)();
});
const $77ac944da51b7354$var$listItems = ()=>document.querySelectorAll('#ed-list li');
function $77ac944da51b7354$var$wireHoverSound(item, hoverSound) {
    item.addEventListener('mouseenter', ()=>{
        hoverSound.muted = (0, $f07d147227763a00$export$589e67d858c44a42)();
        hoverSound.currentTime = 0;
        hoverSound.play().catch(()=>{});
        item.classList.add('hover-effect');
    });
    item.addEventListener('mouseleave', ()=>item.classList.remove('hover-effect'));
}
const $77ac944da51b7354$var$hoverSound = new Audio($77ac944da51b7354$var$HOVER_SOUND_SRC);
$77ac944da51b7354$var$hoverSound.volume = 0.1;
function $77ac944da51b7354$var$initListItems() {
    $77ac944da51b7354$var$listItems().forEach((item, index)=>{
        item.style.animationDelay = `${index * 0.1}s`;
        item.classList.add('slide-in');
        $77ac944da51b7354$var$wireHoverSound(item, $77ac944da51b7354$var$hoverSound);
    });
}
function $77ac944da51b7354$var$initKonamiCode() {
    let konamiIndex = 0;
    const arrowKeyMap = {
        Up: 'ArrowUp',
        Down: 'ArrowDown',
        Left: 'ArrowLeft',
        Right: 'ArrowRight'
    };
    document.addEventListener('keydown', (e)=>{
        // Ignore while typing or while the game owns the keyboard.
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || window.galagaGameActive) return;
        let key = arrowKeyMap[e.key] || e.key;
        if (typeof key === 'string' && key.length === 1) key = key.toLowerCase();
        if (key === $77ac944da51b7354$var$KONAMI_CODE[konamiIndex]) {
            konamiIndex++;
            if (konamiIndex === $77ac944da51b7354$var$KONAMI_CODE.length) {
                $77ac944da51b7354$var$activatePartyMode();
                konamiIndex = 0;
            }
        } else // A wrong key restarts the sequence (but a repeated first key keeps it alive).
        konamiIndex = key === $77ac944da51b7354$var$KONAMI_CODE[0] ? 1 : 0;
    });
}
function $77ac944da51b7354$var$initMonkey() {
    if (!$77ac944da51b7354$var$monkeyImage) return;
    const clickCounter = document.getElementById('click-counter');
    const triggerMonkey = ()=>{
        (0, $f07d147227763a00$export$4c0029b0ace0292a)('monkey');
        $77ac944da51b7354$var$clickCount++;
        if (clickCounter) {
            clickCounter.textContent = `Surveillance triggers: ${$77ac944da51b7354$var$clickCount}`;
            clickCounter.style.color = `hsl(${$77ac944da51b7354$var$clickCount * 10}, 70%, 50%)`;
        }
        $77ac944da51b7354$var$monkeyImage.classList.add('active');
        $77ac944da51b7354$var$playFiestaAudio();
        setTimeout(()=>$77ac944da51b7354$var$monkeyImage.classList.remove('active'), $77ac944da51b7354$var$ACTIVE_PULSE_MS);
        if ($77ac944da51b7354$var$clickCount === $77ac944da51b7354$var$CLICK_CONFETTI) $77ac944da51b7354$var$triggerRandomConfetti();
        if ($77ac944da51b7354$var$clickCount === $77ac944da51b7354$var$CLICK_STARS) {
            $77ac944da51b7354$var$triggerStarsConfetti();
            $77ac944da51b7354$var$monkeyImage.style.animation = 'spin 1s ease-in-out';
            setTimeout(()=>{
                $77ac944da51b7354$var$monkeyImage.style.animation = '';
            }, 1000);
        }
        if ($77ac944da51b7354$var$clickCount === $77ac944da51b7354$var$CLICK_CANNONS) $77ac944da51b7354$var$triggerSideCannonConfetti();
        if ($77ac944da51b7354$var$clickCount === $77ac944da51b7354$var$CLICK_PARTY) {
            $77ac944da51b7354$var$activatePartyMode();
            $77ac944da51b7354$var$clickCount = 0;
        }
    };
    $77ac944da51b7354$var$monkeyImage.addEventListener('click', triggerMonkey);
    $77ac944da51b7354$var$monkeyImage.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            triggerMonkey();
        }
    });
}
function $77ac944da51b7354$var$initChuckles() {
    if (!$77ac944da51b7354$var$chucklesImage || !$77ac944da51b7354$var$chucklesAudio) return;
    const triggerChuckles = ()=>{
        (0, $f07d147227763a00$export$4c0029b0ace0292a)('chuckles');
        $77ac944da51b7354$var$chucklesAudio.muted = (0, $f07d147227763a00$export$589e67d858c44a42)();
        $77ac944da51b7354$var$chucklesImage.classList.add('active');
        $77ac944da51b7354$var$chucklesAudio.currentTime = 0;
        $77ac944da51b7354$var$chucklesAudio.play().catch(()=>{});
        setTimeout(()=>$77ac944da51b7354$var$chucklesImage.classList.remove('active'), $77ac944da51b7354$var$ACTIVE_PULSE_MS);
    };
    $77ac944da51b7354$var$chucklesImage.addEventListener('click', triggerChuckles);
    $77ac944da51b7354$var$chucklesImage.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            triggerChuckles();
        }
    });
}
function $77ac944da51b7354$var$initAddItem() {
    const addItemBtn = document.getElementById('add-item-btn');
    const edList = document.getElementById('ed-list');
    const issueCount = document.getElementById('issue-count');
    if (!addItemBtn || !edList) return;
    addItemBtn.addEventListener('click', ()=>{
        (0, $f07d147227763a00$export$4c0029b0ace0292a)('complaint');
        if (!$77ac944da51b7354$var$complaintDeck.length) {
            $77ac944da51b7354$var$complaintDeck = [
                ...$77ac944da51b7354$var$FUNNY_ITEMS
            ];
            for(let i = $77ac944da51b7354$var$complaintDeck.length - 1; i > 0; i--){
                const j = Math.floor(Math.random() * (i + 1));
                [$77ac944da51b7354$var$complaintDeck[i], $77ac944da51b7354$var$complaintDeck[j]] = [
                    $77ac944da51b7354$var$complaintDeck[j],
                    $77ac944da51b7354$var$complaintDeck[i]
                ];
            }
        }
        const randomItem = $77ac944da51b7354$var$complaintDeck.pop();
        const newLi = document.createElement('li');
        newLi.setAttribute('data-severity', randomItem.severity);
        newLi.textContent = randomItem.text;
        newLi.title = `Evidence #215-${String(edList.children.length + 1).padStart(3, '0')} \u{2022} Investigator: concerned coworker`;
        newLi.style.animationDelay = '0s';
        newLi.classList.add('slide-in');
        edList.appendChild(newLi);
        document.getElementById('dossier-status').textContent = `Complaint filed: ${randomItem.text}`;
        if (issueCount) {
            issueCount.textContent = edList.children.length;
            issueCount.style.animation = `pulse ${$77ac944da51b7354$var$PULSE_MS}ms`;
            setTimeout(()=>{
                issueCount.style.animation = '';
            }, $77ac944da51b7354$var$PULSE_MS);
        }
        $77ac944da51b7354$var$wireHoverSound(newLi, $77ac944da51b7354$var$hoverSound);
    });
}
function $77ac944da51b7354$var$initDaysCounter() {
    const daysCounter = document.getElementById('days-counter');
    if (!daysCounter) return;
    const incidents = [
        'Ed opened another tab.',
        'A sales demo was accepted.',
        'The meeting started. Ed did not.',
        'A Slack message entered witness protection.',
        'Ed is circling back. Location unknown.'
    ];
    let incident = 0;
    setInterval(()=>{
        if (document.hidden || window.galagaGameActive) return;
        daysCounter.textContent = '0.99';
        document.getElementById('incident-note').textContent = "Almost a whole day. Stand by\u2026";
        setTimeout(()=>{
            daysCounter.textContent = '0';
            daysCounter.style.animation = `shake ${$77ac944da51b7354$var$PULSE_MS}ms`;
            document.getElementById('incident-note').textContent = incidents[incident++ % incidents.length];
            setTimeout(()=>{
                daysCounter.style.animation = '';
            }, $77ac944da51b7354$var$PULSE_MS);
        }, 1800);
    }, 18000);
}
function $77ac944da51b7354$var$initCursorRotation() {
    // Motion gimmick — skip entirely for reduced-motion users.
    if ($77ac944da51b7354$var$isReducedMotion) return;
    const mainContainer = document.querySelector('.container');
    if (!mainContainer) return;
    // Compute the container rect lazily on click (no per-mousemove layout reads).
    document.addEventListener('click', (e)=>{
        const rect = mainContainer.getBoundingClientRect();
        const outside = e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom;
        if (outside) {
            $77ac944da51b7354$var$cursorRotation += 45;
            $77ac944da51b7354$var$updateCursor();
        }
    });
}
function $77ac944da51b7354$var$initGalagaButton() {
    const galagaBtn = document.getElementById('galaga-btn');
    if (galagaBtn) galagaBtn.addEventListener('click', ()=>(0, $c3a9b968ea1563a7$export$fda4df29dd45d459)());
}
// The declassify lever fires the same party mode as the Konami code.
function $77ac944da51b7354$var$initLeverSwitch() {
    const lever = document.getElementById('declassify-lever');
    if (!lever) return;
    lever.addEventListener('change', ()=>{
        if (!lever.checked) return;
        (0, $f07d147227763a00$export$4c0029b0ace0292a)('lever');
        $77ac944da51b7354$var$activatePartyMode();
        // Snap the lever back to OFF once the party ends, so it can be pulled again.
        setTimeout(()=>{
            lever.checked = false;
        }, $77ac944da51b7354$var$PARTY_DURATION_MS);
    });
}
// ============================================================================
// PARTY MODE (re-entry guarded so triggers can't stack)
// ============================================================================
function $77ac944da51b7354$var$activatePartyMode() {
    if ($77ac944da51b7354$var$partyActive) return; // ignore re-triggers while a party is already running
    $77ac944da51b7354$var$partyActive = true;
    document.body.classList.add('party-mode');
    $77ac944da51b7354$var$playFiestaAudio();
    const currentMode = $77ac944da51b7354$var$partyModeType;
    if ($77ac944da51b7354$var$partyModeType === 'confetti') {
        $77ac944da51b7354$var$triggerFireworksConfetti();
        $77ac944da51b7354$var$partyModeType = 'balloons';
    } else if ($77ac944da51b7354$var$partyModeType === 'balloons') {
        $77ac944da51b7354$var$triggerBalloonsAnimation();
        $77ac944da51b7354$var$partyModeType = 'rainbow';
    } else {
        $77ac944da51b7354$var$triggerRainbowMode();
        $77ac944da51b7354$var$partyModeType = 'confetti';
    }
    // Rainbow mode styles the title itself; other modes get a temporary flash.
    const h1 = document.querySelector('h1');
    if (h1 && currentMode !== 'rainbow') {
        h1.classList.add('rainbow-text');
        setTimeout(()=>h1.classList.remove('rainbow-text'), $77ac944da51b7354$var$TITLE_FLASH_MS);
    }
    setTimeout(()=>{
        document.body.classList.remove('party-mode');
        $77ac944da51b7354$var$partyActive = false;
        $77ac944da51b7354$var$fiestaAudio?.pause();
    }, $77ac944da51b7354$var$PARTY_DURATION_MS);
}
async function $77ac944da51b7354$var$triggerFireworksConfetti() {
    const confetti = await $77ac944da51b7354$var$loadConfetti();
    if ($77ac944da51b7354$var$isReducedMotion) return;
    const startTime = Date.now();
    const defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: $77ac944da51b7354$var$isMobileViewport ? 40 : 60,
        zIndex: 0,
        colors: $77ac944da51b7354$var$CONFETTI_COLORS
    };
    const randomInRange = (min, max)=>Math.random() * (max - min) + min;
    const createConfettiBurst = ()=>{
        const burstEnd = Date.now() + $77ac944da51b7354$var$CONFETTI_BURST_MS;
        const interval = setInterval(()=>{
            const timeLeft = burstEnd - Date.now();
            if (timeLeft <= 0) return clearInterval(interval);
            const particleCount = $77ac944da51b7354$var$scaleParticles(50 * (timeLeft / $77ac944da51b7354$var$CONFETTI_BURST_MS));
            if (particleCount <= 0) return;
            confetti({
                ...defaults,
                particleCount: particleCount,
                origin: {
                    x: randomInRange(0.1, 0.3),
                    y: Math.random() - 0.2
                }
            });
            confetti({
                ...defaults,
                particleCount: particleCount,
                origin: {
                    x: randomInRange(0.7, 0.9),
                    y: Math.random() - 0.2
                }
            });
        }, 250);
    };
    createConfettiBurst();
    const repeatTimer = setInterval(()=>{
        if (Date.now() - startTime >= $77ac944da51b7354$var$PARTY_DURATION_MS) {
            clearInterval(repeatTimer);
            return;
        }
        createConfettiBurst();
    }, $77ac944da51b7354$var$CONFETTI_REPEAT_MS);
}
async function $77ac944da51b7354$var$triggerSideCannonConfetti() {
    const confetti = await $77ac944da51b7354$var$loadConfetti();
    if ($77ac944da51b7354$var$isReducedMotion) return;
    const end = Date.now() + 3000;
    const colors = [
        '#a786ff',
        '#fd8bbc',
        '#eca184',
        '#f8deb1'
    ];
    const frame = ()=>{
        if (Date.now() > end) return;
        const count = $77ac944da51b7354$var$scaleParticles(2);
        if (count > 0) {
            confetti({
                particleCount: count,
                angle: 60,
                spread: 55,
                startVelocity: 60,
                origin: {
                    x: 0,
                    y: 0.5
                },
                colors: colors
            });
            confetti({
                particleCount: count,
                angle: 120,
                spread: 55,
                startVelocity: 60,
                origin: {
                    x: 1,
                    y: 0.5
                },
                colors: colors
            });
        }
        requestAnimationFrame(frame);
    };
    frame();
}
async function $77ac944da51b7354$var$triggerStarsConfetti() {
    const confetti = await $77ac944da51b7354$var$loadConfetti();
    if ($77ac944da51b7354$var$isReducedMotion) return;
    const defaults = {
        spread: 360,
        ticks: $77ac944da51b7354$var$isMobileViewport ? 35 : 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: [
            '#FFE400',
            '#FFBD00',
            '#E89400',
            '#FFCA6C',
            '#FDFFB8'
        ]
    };
    const shoot = ()=>{
        const c1 = $77ac944da51b7354$var$scaleParticles(40);
        const c2 = $77ac944da51b7354$var$scaleParticles(10);
        if (c1 > 0) confetti({
            ...defaults,
            particleCount: c1,
            scalar: 1.2,
            shapes: [
                'star'
            ]
        });
        if (c2 > 0) confetti({
            ...defaults,
            particleCount: c2,
            scalar: 0.75,
            shapes: [
                'circle'
            ]
        });
    };
    setTimeout(shoot, 0);
    setTimeout(shoot, 100);
    setTimeout(shoot, 200);
}
async function $77ac944da51b7354$var$triggerRandomConfetti() {
    const confetti = await $77ac944da51b7354$var$loadConfetti();
    if ($77ac944da51b7354$var$isReducedMotion) return;
    const count = $77ac944da51b7354$var$scaleParticles(100);
    if (count > 0) confetti({
        angle: Math.random() * 360,
        spread: 55,
        particleCount: count,
        origin: {
            x: 0.5,
            y: 0.8
        },
        colors: [
            '#FFE400',
            '#FFBD00',
            '#E89400',
            '#FFCA6C',
            '#FDFFB8',
            '#a786ff',
            '#fd8bbc'
        ]
    });
}
// CSS-only 3D balloon fallback when the balloons library is unavailable.
function $77ac944da51b7354$var$createProfessionalBalloons() {
    const container = document.createElement('div');
    container.className = 'professional-balloons-container';
    container.style.cssText = `
    position: fixed; inset: 0; z-index: 999; pointer-events: none;
    perspective: 1500px; perspective-origin: 50vw 100vh; overflow: hidden;
  `;
    document.body.appendChild(container);
    const colorPairs = [
        [
            '#ffec37',
            '#f8b13d'
        ],
        [
            '#f89640',
            '#c03940'
        ],
        [
            '#3bc0f0',
            '#0075bc'
        ],
        [
            '#b0cb47',
            '#3d954b'
        ],
        [
            '#cf85b8',
            '#a3509d'
        ]
    ];
    const amount = Math.max(7, Math.round(window.innerWidth / 120));
    for(let i = 0; i < amount; i++){
        const [balloonColor, lightColor] = colorPairs[Math.floor(Math.random() * colorPairs.length)];
        const balloon = document.createElement('div');
        balloon.className = 'professional-balloon';
        const size = 80 + Math.random() * 40;
        const x = Math.random() * window.innerWidth;
        const z = -Math.random() * 800;
        const blur = Math.abs(z) / 100;
        balloon.style.cssText = `
      position: absolute; left: ${x}px; top: 100vh;
      width: ${size}px; height: ${size * 1.3}px;
      background: linear-gradient(135deg, ${balloonColor} 0%, ${lightColor} 100%);
      border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
      transform: translateX(-50%) translateZ(${z}px);
      filter: blur(${blur}px);
      z-index: ${Math.floor(1000 - Math.abs(z))};
      pointer-events: none; --z: ${z}px;
      box-shadow: inset -10px -10px 20px rgba(0,0,0,0.3), inset 15px 15px 30px rgba(255,255,255,0.6), 0 10px 30px rgba(0,0,0,0.2);
      animation: professional-balloon-float ${8 + Math.random() * 4}s ease-out forwards;
      animation-delay: ${i * 200}ms;
    `;
        const highlight = document.createElement('div');
        highlight.style.cssText = `
      position: absolute; top: 15%; left: 25%; width: 25%; height: 35%;
      background: radial-gradient(ellipse at center, rgba(255,255,255,0.8) 0%, transparent 70%);
      border-radius: 50%; transform: rotate(-25deg);
    `;
        balloon.appendChild(highlight);
        const string = document.createElement('div');
        string.style.cssText = `
      position: absolute; left: 50%; top: 100%; width: 2px; height: 30px;
      background: linear-gradient(to bottom, #666, #333); transform: translateX(-50%); border-radius: 1px;
    `;
        balloon.appendChild(string);
        container.appendChild(balloon);
    }
    setTimeout(()=>container.remove(), 12000);
}
function $77ac944da51b7354$var$triggerRainbowMode() {
    document.body.classList.add('party-background');
    const textElements = document.querySelectorAll('h1, .rainbow-target');
    textElements.forEach((el)=>el.classList.add('rainbow-text'));
    const container = document.querySelector('.container, main, body');
    if (container) container.classList.add('rainbow-border');
    $77ac944da51b7354$var$createRainbowParticles();
    setTimeout(()=>{
        document.body.classList.remove('party-background');
        textElements.forEach((el)=>el.classList.remove('rainbow-text'));
        if (container) container.classList.remove('rainbow-border');
    }, $77ac944da51b7354$var$PARTY_DURATION_MS);
}
function $77ac944da51b7354$var$createRainbowParticles() {
    if ($77ac944da51b7354$var$isReducedMotion) return;
    const container = document.createElement('div');
    container.className = 'rainbow-particles-container';
    container.style.cssText = 'position: fixed; inset: 0; z-index: 998; pointer-events: none; overflow: hidden;';
    document.body.appendChild(container);
    const particleCount = window.innerWidth < 768 ? 8 : 15;
    for(let i = 0; i < particleCount; i++){
        const particle = document.createElement('div');
        particle.className = 'rainbow-particle';
        const size = 20 + Math.random() * 30;
        const x = Math.random() * window.innerWidth;
        const duration = 6 + Math.random() * 4;
        const delay = Math.random() * 2;
        particle.style.cssText = `
      position: absolute; left: ${x}px; top: 100vh; width: ${size}px; height: ${size}px;
      background: linear-gradient(45deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #9400d3, #ff0000);
      background-size: 300% 300%; border-radius: 50%;
      animation: rainbow-particle-float ${duration}s ease-out forwards, rainbow-gradient ${duration / 2}s linear infinite;
      animation-delay: ${delay}s; box-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
    `;
        container.appendChild(particle);
    }
    setTimeout(()=>container.remove(), 10000);
}
// Rotating custom cursor (👉 with an occasional 🖕) for clicks outside the dossier.
function $77ac944da51b7354$var$updateCursor() {
    const normalizedRotation = $77ac944da51b7354$var$cursorRotation % 360;
    const cursorEmojis = [
        "\uD83D\uDC49",
        "\uD83D\uDC49",
        "\uD83D\uDC49",
        "\uD83D\uDC49",
        "\uD83D\uDD95"
    ]; // 80% pointer, 20% rude
    const selectedEmoji = cursorEmojis[Math.floor(Math.random() * cursorEmojis.length)];
    const cursorSvg = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" style="font-size: 24px"><text y="24" transform="rotate(${normalizedRotation} 16 16)">${selectedEmoji}</text></svg>`;
    document.body.style.cursor = `url('${cursorSvg}') 4 4, auto`;
}
// ============================================================================
// VIDEO MODAL
// ============================================================================
const $77ac944da51b7354$var$videoModal = document.getElementById('video-modal');
const $77ac944da51b7354$var$videoModalBackdrop = document.getElementById('video-modal-backdrop');
const $77ac944da51b7354$var$videoModalClose = document.getElementById('video-modal-close');
const $77ac944da51b7354$var$videoModalPlayer = document.getElementById('video-modal-player');
const $77ac944da51b7354$var$videoPlayBtn = document.getElementById('video-play-btn');
const $77ac944da51b7354$var$MUX_VIDEO_URL = 'https://player.mux.com/o21k0000sIF4TQTGx02fpk3cdlJHLIm5WnzigUU4jEW18A?metadata-video-title=Chuckles&video-title=Chuckles&accent-color=%233a3a3a&loop=true&autoplay=true';
function $77ac944da51b7354$var$openVideoModal() {
    if (!$77ac944da51b7354$var$videoModal || !$77ac944da51b7354$var$videoModalPlayer) return;
    (0, $f07d147227763a00$export$4c0029b0ace0292a)('footage');
    (0, $f07d147227763a00$export$f29aa9650e04f442)();
    const iframe = document.createElement('iframe');
    iframe.src = $77ac944da51b7354$var$MUX_VIDEO_URL + ((0, $f07d147227763a00$export$589e67d858c44a42)() ? '&muted=true' : '');
    iframe.title = 'Chuckles surveillance footage';
    iframe.allow = 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;';
    iframe.allowFullscreen = true;
    $77ac944da51b7354$var$videoModalPlayer.innerHTML = '';
    $77ac944da51b7354$var$videoModalPlayer.appendChild(iframe);
    $77ac944da51b7354$var$videoModal.showModal();
    $77ac944da51b7354$var$videoModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    if ($77ac944da51b7354$var$videoModalClose) $77ac944da51b7354$var$videoModalClose.focus();
}
function $77ac944da51b7354$var$closeVideoModal() {
    if (!$77ac944da51b7354$var$videoModal || !$77ac944da51b7354$var$videoModalPlayer) return;
    $77ac944da51b7354$var$videoModal.classList.remove('active');
    if ($77ac944da51b7354$var$videoModal.open) $77ac944da51b7354$var$videoModal.close();
    document.body.style.overflow = '';
    $77ac944da51b7354$var$videoModalPlayer.innerHTML = ''; // removing the iframe stops playback
    if ($77ac944da51b7354$var$videoPlayBtn) $77ac944da51b7354$var$videoPlayBtn.focus();
}
if ($77ac944da51b7354$var$videoPlayBtn) $77ac944da51b7354$var$videoPlayBtn.addEventListener('click', $77ac944da51b7354$var$openVideoModal);
if ($77ac944da51b7354$var$videoModalClose) $77ac944da51b7354$var$videoModalClose.addEventListener('click', $77ac944da51b7354$var$closeVideoModal);
if ($77ac944da51b7354$var$videoModalBackdrop) $77ac944da51b7354$var$videoModalBackdrop.addEventListener('click', $77ac944da51b7354$var$closeVideoModal);
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape' && $77ac944da51b7354$var$videoModal && $77ac944da51b7354$var$videoModal.classList.contains('active')) $77ac944da51b7354$var$closeVideoModal();
});
$77ac944da51b7354$var$videoModal?.addEventListener('cancel', (event)=>{
    event.preventDefault();
    $77ac944da51b7354$var$closeVideoModal();
});


//# sourceMappingURL=special-ed.dbb7cf7e.js.map
